import { useMutation, useQuery, UseMutationOptions, UseQueryOptions } from '@tanstack/react-query';
import { fetcher } from '@/graphql/fetcher';
export type Maybe<T> = T | null;
export type InputMaybe<T> = Maybe<T>;
export type Exact<T extends { [key: string]: unknown }> = { [K in keyof T]: T[K] };
export type MakeOptional<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]?: Maybe<T[SubKey]> };
export type MakeMaybe<T, K extends keyof T> = Omit<T, K> & { [SubKey in K]: Maybe<T[SubKey]> };
/** All built-in and custom scalars, mapped to their actual values */
export type Scalars = {
  ID: string;
  String: string;
  Boolean: boolean;
  Int: number;
  Float: number;
  BigInt: any;
  ISO8601Date: any;
  ISO8601DateTime: any;
};

export const AuthenticationKindEnum = {
  /** Translation missing: ja.enumerize.tentative_customer.authentication_kind.auth_guest_email */
  AuthGuestEmail: 'auth_guest_email',
  /** Translation missing: ja.enumerize.tentative_customer.authentication_kind.login */
  Login: 'login',
  /** Translation missing: ja.enumerize.tentative_customer.authentication_kind.register_email */
  RegisterEmail: 'register_email',
  /** Translation missing: ja.enumerize.tentative_customer.authentication_kind.register_tel */
  RegisterTel: 'register_tel',
  /** パスワードリセット */
  ResetPassword: 'reset_password',
  /** 新規登録 */
  SignUp: 'sign_up',
  /** メールアドレス変更 */
  UpdateEmail: 'update_email',
  /** 電話番号変更 */
  UpdateTel: 'update_tel'
} as const;

export type AuthenticationKindEnum = typeof AuthenticationKindEnum[keyof typeof AuthenticationKindEnum];
export const AvailableSexTypeEnum = {
  /** 男女OK */
  Both: 'both',
  /** 女性のみ */
  Female: 'female',
  /** 男性のみ */
  Male: 'male'
} as const;

export type AvailableSexTypeEnum = typeof AvailableSexTypeEnum[keyof typeof AvailableSexTypeEnum];
/** バナー管理 */
export type BannerObject = TimestampInterface & {
  __typename?: 'BannerObject';
  /** altタイトル */
  altText: Scalars['String'];
  /** 作成日時 */
  createdAt: Scalars['ISO8601DateTime'];
  /** バナーID */
  id: Scalars['Int'];
  /** 画像用リンク */
  imageLink: Scalars['String'];
  /** pc用バナー画像 */
  pcImage: Scalars['String'];
  /** 掲載開始日 */
  publishedStartAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** 順番 */
  sortNo: Scalars['Int'];
  /** sp用バナー画像 */
  spImage: Scalars['String'];
  /** 更新日時 */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** ブログ情報 */
export type BlogObject = {
  __typename?: 'BlogObject';
  /** ブログ本文 */
  content: Scalars['String'];
  /** 作成日時 */
  createdAt: Scalars['ISO8601DateTime'];
  /** アイキャッチ画像 */
  eyeCatchingImage?: Maybe<Scalars['String']>;
  /** 店舗予約可能フラグ */
  isShopBookable: Scalars['Boolean'];
  /** 店舗名 */
  shopName: Scalars['String'];
  /** ブログ投稿店舗のスラッグ */
  shopSlug: Scalars['String'];
  /** 店舗電話番号 */
  shopTel?: Maybe<Scalars['String']>;
  /** スラッグ */
  slug?: Maybe<Scalars['String']>;
  /** 公開状況 */
  status: Scalars['String'];
  /** タイトル */
  title: Scalars['String'];
  /** 更新日時 */
  updatedAt: Scalars['ISO8601DateTime'];
  /** WP:店舗ID */
  wpAuthorId: Scalars['Int'];
  /** WP:ブログID */
  wpId: Scalars['Int'];
};

export type BlogObjectWithKaminariPagination = {
  __typename?: 'BlogObjectWithKaminariPagination';
  items: Array<BlogObject>;
  pageInfo: KaminariPageInfoObject;
};

/** 予約キャンセル時の入力内容 */
export type BookingCancelInput = {
  /** 予約キャンセル詳細` */
  cancelDetail?: InputMaybe<Scalars['String']>;
  /** 予約キャンセル種別 */
  cancelType?: InputMaybe<BookingCancelTypeEnum>;
  /** PM予約ID */
  pmBookingId?: InputMaybe<Scalars['BigInt']>;
};

/** Autogenerated input type of BookingCancelMutation */
export type BookingCancelMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  params: BookingCancelParams;
};

/** Autogenerated return type of BookingCancelMutation */
export type BookingCancelMutationPayload = {
  __typename?: 'BookingCancelMutationPayload';
  /** 予約キャンセル情報 */
  bookingCancelled: BookingCancelObject;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** 予約キャンセル結果 */
  result: Scalars['Boolean'];
};

export type BookingCancelObject = {
  __typename?: 'BookingCancelObject';
  /** 予約キャンセル完了フラグ */
  status: Scalars['Boolean'];
};

export type BookingCancelParams = {
  /** 予約キャンセル時の入力パラメータ */
  bookingCancelParams: BookingCancelInput;
};

export const BookingCancelTypeEnum = {
  /** 急用が入ったため */
  Emergency: 'emergency',
  /** 前の予定が延びたため */
  ExtendedSchedule: 'extended_schedule',
  /** 体調不良のため */
  Illness: 'illness',
  /** その他（自由記述） */
  Other: 'other',
  /** 予約時間変更のため */
  Reschedule: 'reschedule'
} as const;

export type BookingCancelTypeEnum = typeof BookingCancelTypeEnum[keyof typeof BookingCancelTypeEnum];
/** キャンセル種別 */
export type BookingCancelTypeObject = {
  __typename?: 'BookingCancelTypeObject';
  /** 名前 */
  text: Scalars['String'];
  /** 値 */
  value: BookingCancelTypeEnum;
};

/** 予約完了時の返却情報 */
export type BookingCompletedObject = {
  __typename?: 'BookingCompletedObject';
  /** ReRaKuDB 予約ID */
  bookingId?: Maybe<Scalars['BigInt']>;
  /** 予約したメニューの内容 */
  bookingMenu?: Maybe<Array<BookingCourseCategoryObject>>;
  /** 予約時のコメント */
  comment?: Maybe<Scalars['String']>;
  /** 終了時刻 */
  endTime?: Maybe<Scalars['String']>;
  /** PM予約ID */
  pmBookingId: Scalars['BigInt'];
  /** PM顧客ID */
  pmCustomerId?: Maybe<Scalars['BigInt']>;
  /** PM店舗ID */
  pmShopId?: Maybe<Scalars['BigInt']>;
  /** PM店舗名 */
  pmShopName?: Maybe<Scalars['String']>;
  /** PMスタッフ名 */
  pmStaffName?: Maybe<Scalars['String']>;
  /** 予約日 */
  startDate?: Maybe<Scalars['String']>;
  /** 開始時刻 */
  startTime?: Maybe<Scalars['String']>;
  /** 予約結果ステータス(trueが返る前提) */
  status: Scalars['Boolean'];
  /** 予約メニュー総額 */
  totalPrice?: Maybe<Scalars['Int']>;
};

/** 予約時のコース内容 */
export type BookingConfirmInput = {
  /** 予約コース */
  courses?: InputMaybe<Array<BookingCourseInput>>;
  /** 日付（yyyy-mm-dd） */
  date?: InputMaybe<Scalars['String']>;
  /** PM店舗ID */
  pmShopId?: InputMaybe<Scalars['BigInt']>;
  /** PMスタッフID */
  pmStaffId?: InputMaybe<Scalars['BigInt']>;
  /** 男女希望フラグ。男性希望: 1, 女性希望: 2 */
  staffSexId?: InputMaybe<Scalars['Int']>;
  /** 開始日時 */
  startTime?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of BookingConfirmMutation */
export type BookingConfirmMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  params: BookingConfirmParams;
};

/** Autogenerated return type of BookingConfirmMutation */
export type BookingConfirmMutationPayload = {
  __typename?: 'BookingConfirmMutationPayload';
  /** 予約情報 */
  bookingConfirmInfo?: Maybe<BookingConfirmObject>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** 予約結果 */
  result: Scalars['Boolean'];
};

/** 予約前の確認情報 */
export type BookingConfirmNominateInfoObject = {
  __typename?: 'BookingConfirmNominateInfoObject';
  /** 指名(オプション)のID */
  courseOptionId?: Maybe<Scalars['BigInt']>;
  /** 「指名」のコース名（オプション名） */
  courseOptionName?: Maybe<Scalars['String']>;
  /** 料金(税抜) */
  noTaxPrice?: Maybe<Scalars['Int']>;
  /** 料金(税込) */
  price?: Maybe<Scalars['Int']>;
};

/** 予約前の確認情報 */
export type BookingConfirmObject = {
  __typename?: 'BookingConfirmObject';
  /** 予約コース内容 */
  bookingMenu: Array<BookingCourseCategoryObject>;
  /** 予約確認APIが返却する、リクエスト可能なコースのパラメータ */
  courseParams: Array<BookingCourseParamsObject>;
  /** 顧客情報 */
  customer?: Maybe<CustomerObject>;
  /** 指定コースのidに変更があるか */
  hasCourseIdsChanged: Scalars['Boolean'];
  /** 予約可否 */
  isBookable: Scalars['Boolean'];
  /** 指名内容 */
  nominateInfo?: Maybe<BookingConfirmNominateInfoObject>;
  /** 指名料（税込） */
  nominationFee?: Maybe<Scalars['Int']>;
  /** 予約総額(指名オプション込み) */
  totalPrice: Scalars['Int'];
  /** 予約総額(コースのみ) */
  totalPriceWithoutNominationFee: Scalars['Int'];
};

export type BookingConfirmParams = {
  /** 予約確認内容 */
  bookingConfirmParams: BookingConfirmInput;
};

/** 予約内容（コースカテゴリ） */
export type BookingCourseCategoryObject = {
  __typename?: 'BookingCourseCategoryObject';
  /** 予約コース情報 */
  courses: Array<BookingCourseObject>;
  /** カテゴリ名 */
  name: Scalars['String'];
  /** 予約コースオプション情報 */
  options: Array<BookingCourseObject>;
  /** PMコースカテゴリID */
  pmCourseCategoryId: Scalars['BigInt'];
};

/** 予約時のコース内容 */
export type BookingCourseInput = {
  /** 指定コースのコースカテゴリ */
  pmCourseCategoryId: Scalars['BigInt'];
  /** 指定のコース */
  pmCourseId: Scalars['BigInt'];
  /** 指定コースのオプション */
  pmCourseOptionIds: Array<Scalars['BigInt']>;
};

/** 予約内容（コース） */
export type BookingCourseObject = {
  __typename?: 'BookingCourseObject';
  /** コース名 */
  name: Scalars['String'];
  /** コース料金(税抜) */
  noTaxPrice: Scalars['Int'];
  /** PMコースID */
  pmCourseId: Scalars['BigInt'];
  /** コース料金(税込) */
  price: Scalars['Int'];
  /** コース対象性別(0: 男性、1: 女性、2: 男女) */
  sex: Scalars['Int'];
  /** コース時間 */
  time: Scalars['Int'];
};

/** 予約履歴、予約確認後のコースパラメータ */
export type BookingCourseParamsObject = {
  __typename?: 'BookingCourseParamsObject';
  /** PMコースカテゴリID */
  pmCourseCategoryId?: Maybe<Scalars['BigInt']>;
  /** PMコースID */
  pmCourseId?: Maybe<Scalars['BigInt']>;
  /** PMオプションIDの配列 */
  pmCourseOptionIds?: Maybe<Array<Scalars['BigInt']>>;
};

/** Autogenerated input type of BookingGuestInputMutation */
export type BookingGuestInputMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  params: BookingGuestInputParams;
};

/** Autogenerated return type of BookingGuestInputMutation */
export type BookingGuestInputMutationPayload = {
  __typename?: 'BookingGuestInputMutationPayload';
  /** 予約情報 */
  booking?: Maybe<BookingCompletedObject>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** 予約結果 */
  result: Scalars['Boolean'];
};

export type BookingGuestInputParams = {
  /** 認証トークン */
  authenticationToken: Scalars['String'];
  /** コメント */
  comment?: InputMaybe<Scalars['String']>;
  /** 予約コース */
  courses: Array<BookingCourseInput>;
  /** 日付（yyyy-mm-dd） */
  date: Scalars['String'];
  /** 顧客情報 */
  guestCustomerInfo: GuestCustomerInput;
  /** PM店舗ID */
  pmShopId: Scalars['BigInt'];
  /** PMスタッフID */
  pmStaffId?: InputMaybe<Scalars['BigInt']>;
  /** 男女希望フラグ。男性希望: 1, 女性希望: 2 */
  staffSexId?: InputMaybe<Scalars['Int']>;
  /** 開始日時 */
  startTime: Scalars['String'];
  /** utmパラメータ */
  trackingParameter?: InputMaybe<TrackingParameterInput>;
};

/** 予約履歴情報 */
export type BookingHistoryObject = {
  __typename?: 'BookingHistoryObject';
  /** 予約履歴PMコース */
  bookingHistoryCourses: Array<BookingCourseParamsObject>;
  /** 予約履歴キャンセル日時 */
  cancelledDate?: Maybe<Scalars['String']>;
  /** 予約履歴コース名 */
  courseName: Array<Scalars['String']>;
  /** 予約履歴ReRaKuカスタマーID */
  customerId: Scalars['Int'];
  /** 予約履歴指名スタッフID */
  designedStaffId?: Maybe<Scalars['BigInt']>;
  /** 予約履歴施術終了確認フラグ */
  isAlreadyTreated: Scalars['Boolean'];
  /** 予約履歴キャンセル可能確認フラグ */
  isCancellable: Scalars['Boolean'];
  /** 予約履歴の同じコースで予約可能か */
  isCourseBookable: Scalars['Boolean'];
  /** 指名確認フラグ */
  isDesignated: Scalars['Boolean'];
  /** 閉店店舗確認フラグ */
  isShopClosed: Scalars['Boolean'];
  /** 予約履歴オプション名 */
  options: Array<Scalars['String']>;
  /** 予約履歴PM予約ID */
  pmBookingId: Scalars['BigInt'];
  /** 予約履歴PMカスタマーID */
  pmCustomerId: Scalars['BigInt'];
  /** 予約履歴PM店舗ID */
  pmShopId: Scalars['BigInt'];
  /** 予約履歴合計金額 */
  price: Scalars['Int'];
  /** 予約履歴店舗名 */
  shopName: Scalars['String'];
  /** 店舗スラッグ */
  shopSlug?: Maybe<Scalars['String']>;
  /** 予約履歴店舗電話番号 */
  shopTel: Scalars['String'];
  /** 予約履歴店舗URL */
  shopUrl: Scalars['String'];
  /** 予約履歴スタッフ名 */
  staffName: Array<Scalars['String']>;
  /** 予約履歴施術開始時間 */
  startTime: Scalars['String'];
};

export type BookingHistoryObjectWithKaminariPagination = {
  __typename?: 'BookingHistoryObjectWithKaminariPagination';
  items: Array<BookingHistoryObject>;
  pageInfo: KaminariPageInfoObject;
};

/** Autogenerated input type of BookingInputMutation */
export type BookingInputMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  params: BookingInputParams;
};

/** Autogenerated return type of BookingInputMutation */
export type BookingInputMutationPayload = {
  __typename?: 'BookingInputMutationPayload';
  /** 予約情報 */
  booking?: Maybe<BookingCompletedObject>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** 予約結果 */
  result: Scalars['Boolean'];
};

export type BookingInputParams = {
  /** コメント */
  comment?: InputMaybe<Scalars['String']>;
  /** 予約コース */
  courses: Array<BookingCourseInput>;
  /** 日付（yyyy-mm-dd） */
  date: Scalars['String'];
  /** PM店舗ID */
  pmShopId: Scalars['BigInt'];
  /** PMスタッフID */
  pmStaffId?: InputMaybe<Scalars['BigInt']>;
  /** 男女希望フラグ。男性希望: 1, 女性希望: 2 */
  staffSexId?: InputMaybe<Scalars['Int']>;
  /** 開始日時 */
  startTime: Scalars['String'];
  /** utmパラメータ */
  trackingParameter?: InputMaybe<TrackingParameterInput>;
};

/** ブランドグループ */
export type BrandGroupObject = {
  __typename?: 'BrandGroupObject';
  /** ブランドグループに紐づくブランド */
  brands?: Maybe<Array<BrandObject>>;
  /** ブランドグループID */
  id: Scalars['Int'];
  /** ブランドグループ名 */
  name: Scalars['String'];
  /** ブランドグループ名(カナ表記) */
  nameKana: Scalars['String'];
  rerakuCourseCategories: Array<RerakuCourseCategoryObject>;
  /** URL文字列 */
  urlWord: Scalars['String'];
};


/** ブランドグループ */
export type BrandGroupObjectRerakuCourseCategoriesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isHaveShops?: InputMaybe<Scalars['Boolean']>;
};

/** ブランド */
export type BrandObject = {
  __typename?: 'BrandObject';
  /** ブランドグループ */
  brandGroup?: Maybe<BrandGroupObject>;
  /** ブランドID */
  id: Scalars['Int'];
  /** ブランド名 */
  name: Scalars['String'];
  /** ブランド名(カナ表記) */
  nameKana?: Maybe<Scalars['String']>;
};

/** Autogenerated input type of CheckPmCustomerStatusMutation */
export type CheckPmCustomerStatusMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  params: CheckPmCustomerStatusMutationParams;
};

export type CheckPmCustomerStatusMutationParams = {
  /** mockタイプ(tel mail checkテスト用) */
  mockType?: InputMaybe<Scalars['Int']>;
  /** 認証するメールアドレスor電話番号 */
  telOrEmail?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of CheckPmCustomerStatusMutation */
export type CheckPmCustomerStatusMutationPayload = {
  __typename?: 'CheckPmCustomerStatusMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** PMカスタマーステータス */
  pmCustomerStatus: PmCustomerStatusEnum;
  /** チェック完了フラグ */
  result: Scalars['Boolean'];
};

export type CityObject = {
  __typename?: 'CityObject';
  choCode?: Maybe<Scalars['String']>;
  choName?: Maybe<Scalars['String']>;
  choNameKana?: Maybe<Scalars['String']>;
  cityCode: Scalars['String'];
  cityName: Scalars['String'];
  cityNameKana: Scalars['String'];
  code: Scalars['String'];
  id: Scalars['Int'];
  otherName?: Maybe<Scalars['String']>;
  otherNameKana?: Maybe<Scalars['String']>;
  /** こだわり */
  particularConditions: Array<ParticularConditionObject>;
  postCode: Scalars['String'];
  prefecture: PrefectureObject;
  railroadStations: RailroadStationObjectWithKaminariPagination;
  shopCount: Scalars['Int'];
};


export type CityObjectParticularConditionsArgs = {
  isHaveShops?: InputMaybe<Scalars['Boolean']>;
};


export type CityObjectRailroadStationsArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isHaveShops?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  per?: InputMaybe<Scalars['Int']>;
};

export type CityObjectWithKaminariPagination = {
  __typename?: 'CityObjectWithKaminariPagination';
  items: Array<CityObject>;
  pageInfo: KaminariPageInfoObject;
};

/** コラム管理 */
export type ColumnObject = {
  __typename?: 'ColumnObject';
  /** 本文 */
  content: Scalars['String'];
  /** コラム表示ID */
  displayId: Scalars['String'];
  /** アイキャッチ画像 */
  eyeCatchingImage?: Maybe<Scalars['String']>;
  /** 掲載開始日 */
  publishedStartAt: Scalars['ISO8601DateTime'];
  /** タイトル */
  title: Scalars['String'];
};

export type ColumnObjectWithKaminariPagination = {
  __typename?: 'ColumnObjectWithKaminariPagination';
  items: Array<ColumnObject>;
  pageInfo: KaminariPageInfoObject;
};

/** 店舗の件数 */
export type CountOfShopObject = {
  __typename?: 'CountOfShopObject';
  /** 件数 */
  count: Scalars['Int'];
};

/** コースジャンル（店舗検索用） */
export type CourseGenreObject = {
  __typename?: 'CourseGenreObject';
  /** コースジャンル説明 */
  description?: Maybe<Scalars['String']>;
  /** コースジャンルID */
  id: Scalars['Int'];
  /** コースジャンル名 */
  name: Scalars['String'];
  /** コースジャンル表示順 */
  sortNo: Scalars['Int'];
  /** コースジャンルURL文字列 */
  urlWord: Scalars['String'];
};

export type CourseInterface = {
  /** 女性可フラグ */
  activeFemale: Scalars['Boolean'];
  /** 男性可フラグ */
  activeMale: Scalars['Boolean'];
  /** 所要時間（分） */
  courseMinutes: Scalars['Int'];
  /** 有効期間: 終了日時 */
  endAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** コース名 */
  name: Scalars['String'];
  /** 税抜き価格 */
  noTaxPrice: Scalars['Int'];
  /** PeakManagerコースカテゴリID */
  pmCourseCategoryId: Scalars['BigInt'];
  /** PeakManagerのコースID */
  pmCourseId: Scalars['BigInt'];
  /** 税込み価格 */
  price: Scalars['Int'];
  /** コース説明 */
  remarks: Scalars['String'];
  /** 性別フラグ(0: 男性　1: 女性　2: 男女) */
  sex: Scalars['Int'];
  /** 有効期間: 開始日時 */
  startAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** 各店毎のメニュー (コース・セット・オプションのマスタ)  */
export type CourseObject = CourseInterface & {
  __typename?: 'CourseObject';
  /** 女性可フラグ */
  activeFemale: Scalars['Boolean'];
  /** 男性可フラグ */
  activeMale: Scalars['Boolean'];
  /** 所要時間（分） */
  courseMinutes: Scalars['Int'];
  /** コースタイプ 1: 通常, 2: セット, 3: オプション */
  courseType?: Maybe<Scalars['String']>;
  /** 有効期間: 終了日時 */
  endAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** 画像URL */
  imageUrl?: Maybe<Scalars['String']>;
  /** おすすめコースかどうか */
  isPromotional: Scalars['Boolean'];
  /** コース名 */
  name: Scalars['String'];
  /** 税抜き価格 */
  noTaxPrice: Scalars['Int'];
  /** PeakManagerコースカテゴリID */
  pmCourseCategoryId: Scalars['BigInt'];
  /** PeakManagerのコースID */
  pmCourseId: Scalars['BigInt'];
  /** 税込み価格 */
  price: Scalars['Int'];
  /** おすすめコース画像URL */
  promotionalImageUrl?: Maybe<Scalars['String']>;
  /** コース説明 */
  remarks: Scalars['String'];
  /** 性別フラグ(0: 男性　1: 女性　2: 男女) */
  sex: Scalars['Int'];
  /** 有効期間: 開始日時 */
  startAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** 予約のオプション情報 */
export type CourseOptionObject = CourseInterface & {
  __typename?: 'CourseOptionObject';
  /** 女性可フラグ */
  activeFemale: Scalars['Boolean'];
  /** 男性可フラグ */
  activeMale: Scalars['Boolean'];
  /** 所要時間（分） */
  courseMinutes: Scalars['Int'];
  /** 有効期間: 終了日時 */
  endAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** コース名 */
  name: Scalars['String'];
  /** 税抜き価格 */
  noTaxPrice: Scalars['Int'];
  /** PeakManagerコースカテゴリID */
  pmCourseCategoryId: Scalars['BigInt'];
  /** PeakManagerのコースID */
  pmCourseId: Scalars['BigInt'];
  /** 税込み価格 */
  price: Scalars['Int'];
  /** コース説明 */
  remarks: Scalars['String'];
  /** 性別フラグ(0: 男性　1: 女性　2: 男女) */
  sex: Scalars['Int'];
  /** 有効期間: 開始日時 */
  startAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** 現在地の緯度経度 */
export type CurrentLocationInput = {
  /** 現在地の緯度 */
  currentLat?: InputMaybe<Scalars['Float']>;
  /** 現在地の経度 */
  currentLng?: InputMaybe<Scalars['Float']>;
  /** 現在地からのkmで距離を絞る */
  distanceInKm?: InputMaybe<Scalars['Int']>;
};

export type CustomerCardInfoObject = {
  __typename?: 'CustomerCardInfoObject';
  /** カードバーコード画像URL */
  cardBarcodeUrl?: Maybe<Scalars['String']>;
  /** カード画像URL */
  cardImageUrl?: Maybe<Scalars['String']>;
  /** カスタマーID（権限確認用） */
  id?: Maybe<Scalars['Int']>;
};

export type CustomerChargeHistoryObject = {
  __typename?: 'CustomerChargeHistoryObject';
  /** ポイント（チャージ） */
  charge?: Maybe<Scalars['Int']>;
  /** 有効期限 */
  expiredDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** 付与日時 */
  givenDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** カスタマーID（権限確認用） */
  id?: Maybe<Scalars['Int']>;
  /** 店舗名 */
  shopName?: Maybe<Scalars['String']>;
};

export type CustomerCouponInfoObject = {
  __typename?: 'CustomerCouponInfoObject';
  /** 回数券情報 */
  coupons?: Maybe<Array<CustomerCouponObject>>;
  /** カスタマーID（権限確認用） */
  id?: Maybe<Scalars['Int']>;
  /** 回数券合計枚数 */
  totalCount?: Maybe<Scalars['Int']>;
};

export type CustomerCouponObject = {
  __typename?: 'CustomerCouponObject';
  /** 回数券説明 */
  description?: Maybe<Scalars['String']>;
  /** 有効期限が切れる日付 */
  expiredDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** カスタマーID（権限確認用） */
  id?: Maybe<Scalars['Int']>;
  /** 回数券名 */
  name?: Maybe<Scalars['String']>;
  /** PM回数券ID */
  pmCustomerCouponId?: Maybe<Scalars['BigInt']>;
  /** 回数券残り枚数 */
  remainingNumber?: Maybe<Scalars['Int']>;
};

/** お知らせ管理 */
export type CustomerInformationObject = {
  __typename?: 'CustomerInformationObject';
  /** 本文 */
  body: Scalars['String'];
  /** おしらせ表示ID */
  displayId: Scalars['String'];
  /** アイキャッチ画像 */
  eyeCatchingImage?: Maybe<Scalars['String']>;
  /** 掲載開始日 */
  publishedStartAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** タグ */
  tags: Array<Scalars['String']>;
  /** タイトル */
  title: Scalars['String'];
};

export type CustomerInformationObjectWithKaminariPagination = {
  __typename?: 'CustomerInformationObjectWithKaminariPagination';
  items: Array<CustomerInformationObject>;
  pageInfo: KaminariPageInfoObject;
};

/** カスタマーログイン時の入力内容 */
export type CustomerLoginInput = {
  /** ログインに利用するメールアドレス */
  email?: InputMaybe<Scalars['String']>;
  /** ログインに利用するパスワード */
  password?: InputMaybe<Scalars['String']>;
  /** ログインに利用する電話番号 */
  tel?: InputMaybe<Scalars['String']>;
};

export type CustomerMailMagazineSettingByShopObject = {
  __typename?: 'CustomerMailMagazineSettingByShopObject';
  /** 閉店フラグ（true: 閉店） */
  closed?: Maybe<Scalars['Boolean']>;
  /** カスタマーID（権限確認用） */
  id?: Maybe<Scalars['Int']>;
  /** 店舗メール受信フラグ（0: 受信しない, 1: 受信する） */
  isEnabledToReceiveEmailFromShop?: Maybe<Scalars['Int']>;
  /** PM店舗ID */
  pmShopId?: Maybe<Scalars['BigInt']>;
  /** 店舗名 */
  shopName?: Maybe<Scalars['String']>;
  /** 表示順 */
  sortNo?: Maybe<Scalars['Int']>;
};

/** メルマガ設定変更内容 */
export type CustomerMailMagazineSettingsInput = {
  /** 本部メール受信フラグ（0: 受信しない, 1: 受信する） */
  isEnabledToReceiveEmailFromHeadOffice?: InputMaybe<Scalars['Int']>;
  /** 店舗メール受信設定 */
  isEnabledToReceiveEmailFromShop?: InputMaybe<Array<IsEnabledToReceiveEmailFromShopInput>>;
};

export type CustomerMailMagazineSettingsObject = {
  __typename?: 'CustomerMailMagazineSettingsObject';
  /** 店舗ごとのメール受信設定 */
  emailSettingsByShop?: Maybe<Array<CustomerMailMagazineSettingByShopObject>>;
  /** カスタマーID（権限確認用） */
  id?: Maybe<Scalars['Int']>;
  /** 本部メール受信フラグ（0: 受信しない, 1: 受信する） */
  isEnabledToReceiveEmailFromHeadOffice?: Maybe<Scalars['Int']>;
};

export type CustomerObject = {
  __typename?: 'CustomerObject';
  /** 住所（市区町村・番地） */
  address?: Maybe<Scalars['String']>;
  /** 住所（建物名・部屋番号） */
  address2?: Maybe<Scalars['String']>;
  /** 生年月日 */
  birthday?: Maybe<Scalars['ISO8601DateTime']>;
  /** 予約履歴 */
  bookingHistories?: Maybe<BookingHistoryObjectWithKaminariPagination>;
  /** カード情報 */
  customerCardInfo?: Maybe<CustomerCardInfoObject>;
  /** チャージ履歴 */
  customerChargeHistories?: Maybe<Array<CustomerChargeHistoryObject>>;
  /** 回数券残高 */
  customerCouponInfo?: Maybe<CustomerCouponInfoObject>;
  /** メルマガ設定 */
  customerMailMagazineSettings?: Maybe<CustomerMailMagazineSettingsObject>;
  /** ポイント付与履歴 */
  customerPointHistories?: Maybe<Array<CustomerPointHistoryObject>>;
  /** ポイント、チャージ残高情報 */
  customerPointsAndCharges?: Maybe<CustomerPointsAndChargesObject>;
  /** メールアドレス */
  email?: Maybe<Scalars['String']>;
  /** カスタマーID */
  id: Scalars['Int'];
  /** DM受け取りフラグ( 0: 希望しない, 1: 希望する　) */
  isEnabledToReceiveDm?: Maybe<Scalars['Int']>;
  /** 店舗メール受け取り希望フラグ ( 0: 希望しない, 1: 希望する　) */
  isNeededShopMail: Scalars['Int'];
  /** 名前（PM） */
  name: Scalars['String'];
  /** 名前カナ（PM） */
  nameKana: Scalars['String'];
  /** 16桁カード番号 */
  pmCardId?: Maybe<Scalars['String']>;
  /** 会員番号 */
  pmCustomerCode?: Maybe<Scalars['String']>;
  /** PeakManagerのカスタマーID */
  pmCustomerId: Scalars['BigInt'];
  /** PeakManagerの店舗ID */
  pmShopId: Scalars['BigInt'];
  /** 郵便番号 */
  postCode?: Maybe<Scalars['String']>;
  /** 都道府県ID */
  prefectureId?: Maybe<Scalars['Int']>;
  /** 都道府県名 */
  prefectureName?: Maybe<Scalars['String']>;
  /** 性別（0: 男, 1: 女） */
  sex: Scalars['Int'];
  /** 電話番号 */
  tel?: Maybe<Scalars['String']>;
};

export type CustomerPointHistoryObject = {
  __typename?: 'CustomerPointHistoryObject';
  /** 有効期限 */
  expiredDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** 付与日時 */
  givenDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** カスタマーID（権限確認用） */
  id?: Maybe<Scalars['Int']>;
  /** ポイント */
  point?: Maybe<Scalars['Int']>;
  /** 店舗名 */
  shopName?: Maybe<Scalars['String']>;
};

export type CustomerPointsAndChargesObject = {
  __typename?: 'CustomerPointsAndChargesObject';
  /** チャージ残高に関するテキスト（使用しない想定） */
  chargeDescription?: Maybe<Scalars['String']>;
  /** 直近で失効するポイント数 */
  expiringPoints?: Maybe<Scalars['Int']>;
  /** カスタマーID（権限確認用） */
  id?: Maybe<Scalars['Int']>;
  /** 直近で執行するポイントの有効期限 */
  latestExpiredAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** ポイントの有効期限のテキスト */
  pointExpiredAtDescription?: Maybe<Scalars['String']>;
  /** チャージ残高 */
  remainingCharge?: Maybe<Scalars['Int']>;
  /** ポイント残高 */
  remainingPoints?: Maybe<Scalars['Int']>;
};

/** カスタマー新規登録内容 */
export type CustomerSignUpInput = {
  /** 認証トークン */
  authenticationToken?: InputMaybe<Scalars['String']>;
  /** 生年月日 */
  birthday?: InputMaybe<Scalars['ISO8601Date']>;
  /** メルマガ受け取りフラグ（0: 受け取らない, 1: 受け取る)  */
  isNeededShopMail?: InputMaybe<Scalars['Int']>;
  /** 名前 */
  name?: InputMaybe<Scalars['String']>;
  /** 名前(カナ) */
  nameKana?: InputMaybe<Scalars['String']>;
  /** パスワード */
  password?: InputMaybe<Scalars['String']>;
  /** パスワード(確認用) */
  passwordConfirmation?: InputMaybe<Scalars['String']>;
  /** PM店舗ID */
  pmShopId?: InputMaybe<Scalars['BigInt']>;
  /** 性別（ 0: 男性, 1: 女性)  */
  sex?: InputMaybe<Scalars['Int']>;
  /** 電話番号 */
  tel?: InputMaybe<Scalars['String']>;
};

/** ゲスト予約の顧客情報 */
export type GuestCustomerInput = {
  /** ゲストのEメール */
  guestEmail: Scalars['String'];
  /** ゲストの名前 */
  guestName: Scalars['String'];
  /** ゲストの性別 */
  guestSex?: InputMaybe<Scalars['String']>;
  /** ゲストの電話番号 */
  guestTel?: InputMaybe<Scalars['String']>;
};

/** メルマガ設定変更内容 */
export type IsEnabledToReceiveEmailFromShopInput = {
  /** 店舗メール受信フラグ（0: 受信しない, 1: 受信する） */
  isEnabled?: InputMaybe<Scalars['Int']>;
  /** 店舗ID */
  shopId?: InputMaybe<Scalars['Int']>;
};

/** Kaminariのページネーション */
export type KaminariPageInfoObject = {
  __typename?: 'KaminariPageInfoObject';
  /** 現在のページ */
  currentPage: Scalars['Int'];
  /** 最初のページか */
  isFirstPage: Scalars['Boolean'];
  /** 最後のページか */
  isLastPage: Scalars['Boolean'];
  /** 次のページ */
  nextPage?: Maybe<Scalars['Int']>;
  /** 前のページ */
  prevPage?: Maybe<Scalars['Int']>;
  /** 総件数 */
  totalCount: Scalars['Int'];
  /** 総ページ数 */
  totalPages: Scalars['Int'];
};

/** Autogenerated input type of LoginByTelOrEmailMutation */
export type LoginByTelOrEmailMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  params: LoginByTelOrEmailParams;
};

/** Autogenerated return type of LoginByTelOrEmailMutation */
export type LoginByTelOrEmailMutationPayload = {
  __typename?: 'LoginByTelOrEmailMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** ログインしたカスタマー情報 */
  customer?: Maybe<CustomerObject>;
  /** ログイン結果 */
  result: Scalars['Boolean'];
};

export type LoginByTelOrEmailParams = {
  /** カスタマーログインパラメータ */
  customerLoginParams: CustomerLoginInput;
};

/** Autogenerated input type of LogoutMutation */
export type LogoutMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of LogoutMutation */
export type LogoutMutationPayload = {
  __typename?: 'LogoutMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** ログアウト結果 */
  result: Scalars['Boolean'];
};

export type MasterObject = {
  __typename?: 'MasterObject';
  courseGenres: Array<CourseGenreObject>;
  particularConditions: Array<ParticularConditionObject>;
  paymentMethodPaymentTypes: Array<PaymentMethodPaymentTypeObject>;
  paymentMethods: Array<PaymentMethodObject>;
  shopAreas: Array<ShopShopAreaObject>;
  shopStatuses: Array<ShopStatusObject>;
};

export type Mutation = {
  __typename?: 'Mutation';
  bookingCancel: BookingCancelMutationPayload;
  bookingConfirm: BookingConfirmMutationPayload;
  bookingGuestInput: BookingGuestInputMutationPayload;
  bookingInput: BookingInputMutationPayload;
  customerCheckPmCustomerStatus: CheckPmCustomerStatusMutationPayload;
  customerLogin: LoginByTelOrEmailMutationPayload;
  customerLogout: LogoutMutationPayload;
  customerResetPassword: ResetPasswordInputMutationPayload;
  customerSignUp: SignUpMutationPayload;
  customerUpdateEmail: UpdateCustomerEmailMutationPayload;
  customerUpdateMailMagazineSettings: UpdateCustomerMailMagazineSettingsMutationPayload;
  customerUpdatePassword: UpdateCustomerPasswordMutationPayload;
  customerUpdateProfile: UpdateCustomerProfileMutationPayload;
  customerUpdateTel: UpdateCustomerTelMutationPayload;
  customerValidateAuthenticationCode: ValidateAuthenticationCodeMutationPayload;
  customerVerifyTel: VerifyTelMutationPayload;
  customerVerifyTelOrEmail: VerifyTelOrEmailMutationPayload;
  shopCreateInput: ShopCreateInputMutationPayload;
  shopUpdateInput: ShopUpdateInputMutationPayload;
};


export type MutationBookingCancelArgs = {
  input: BookingCancelMutationInput;
};


export type MutationBookingConfirmArgs = {
  input: BookingConfirmMutationInput;
};


export type MutationBookingGuestInputArgs = {
  input: BookingGuestInputMutationInput;
};


export type MutationBookingInputArgs = {
  input: BookingInputMutationInput;
};


export type MutationCustomerCheckPmCustomerStatusArgs = {
  input: CheckPmCustomerStatusMutationInput;
};


export type MutationCustomerLoginArgs = {
  input: LoginByTelOrEmailMutationInput;
};


export type MutationCustomerLogoutArgs = {
  input: LogoutMutationInput;
};


export type MutationCustomerResetPasswordArgs = {
  input: ResetPasswordInputMutationInput;
};


export type MutationCustomerSignUpArgs = {
  input: SignUpMutationInput;
};


export type MutationCustomerUpdateEmailArgs = {
  input: UpdateCustomerEmailMutationInput;
};


export type MutationCustomerUpdateMailMagazineSettingsArgs = {
  input: UpdateCustomerMailMagazineSettingsMutationInput;
};


export type MutationCustomerUpdatePasswordArgs = {
  input: UpdateCustomerPasswordMutationInput;
};


export type MutationCustomerUpdateProfileArgs = {
  input: UpdateCustomerProfileMutationInput;
};


export type MutationCustomerUpdateTelArgs = {
  input: UpdateCustomerTelMutationInput;
};


export type MutationCustomerValidateAuthenticationCodeArgs = {
  input: ValidateAuthenticationCodeMutationInput;
};


export type MutationCustomerVerifyTelArgs = {
  input: VerifyTelMutationInput;
};


export type MutationCustomerVerifyTelOrEmailArgs = {
  input: VerifyTelOrEmailMutationInput;
};


export type MutationShopCreateInputArgs = {
  input: ShopCreateInputMutationInput;
};


export type MutationShopUpdateInputArgs = {
  input: ShopUpdateInputMutationInput;
};

/** 最寄り駅情報 */
export type NearestRailroadStationInput = {
  /** 説明 */
  note?: InputMaybe<Scalars['String']>;
  /** 駅ID */
  railroadStationId?: InputMaybe<Scalars['Int']>;
  /** 並び順 */
  sortNo?: InputMaybe<Scalars['Int']>;
};

/** 最寄り駅情報 */
export type NearestRailroadStationObject = {
  __typename?: 'NearestRailroadStationObject';
  /** ID */
  id: Scalars['Int'];
  /** 説明 */
  note: Scalars['String'];
  /** 駅 */
  railroadStation: RailroadStationObject;
  /** 駅ID */
  railroadStationId: Scalars['Int'];
  /** 並び順 */
  sortNo: Scalars['Int'];
};

/** こだわり */
export type ParticularConditionObject = {
  __typename?: 'ParticularConditionObject';
  /** こだわりID */
  id: Scalars['Int'];
  /** こだわり名前 */
  name: Scalars['String'];
};

/** 支払い方法 */
export type PaymentMethodObject = {
  __typename?: 'PaymentMethodObject';
  /** 支払い方法ID */
  id: Scalars['Int'];
  /** 画像パス */
  imagePath: Scalars['String'];
  /** 画像URL */
  imageUrl: Scalars['String'];
  /** 支払い方法名前 */
  name: Scalars['String'];
  /** 支払い方法タイプ */
  paymentType: PaymentMethodPaymentTypeEnum;
  /** 支払い方法表示順番 */
  sortNo: Scalars['Int'];
};

export const PaymentMethodPaymentTypeEnum = {
  /** クレジットカード */
  CreditCard: 'credit_card',
  /** プリペイド */
  Prepaid: 'prepaid',
  /** QRコード */
  QrCode: 'qr_code'
} as const;

export type PaymentMethodPaymentTypeEnum = typeof PaymentMethodPaymentTypeEnum[keyof typeof PaymentMethodPaymentTypeEnum];
/** 支払い方法タイプ */
export type PaymentMethodPaymentTypeObject = {
  __typename?: 'PaymentMethodPaymentTypeObject';
  /** 名前 */
  text: Scalars['String'];
  /** 値 */
  value: PaymentMethodPaymentTypeEnum;
};

/** Peak Managerのコースカテゴリ情報（管理画面で用いる） */
export type PeakManagerCourseCategoryObject = {
  __typename?: 'PeakManagerCourseCategoryObject';
  /** コース */
  courses: Array<PeakManagerCourseObject>;
  /** 画像URL */
  imageUrl: Scalars['String'];
  /** コースカテゴリー名 */
  name: Scalars['String'];
  /** PeakManagerのコースカテゴリーID */
  pmCourseCategoryId: Scalars['BigInt'];
  /** コースカテゴリー説明 */
  remarks: Scalars['String'];
};

/** Peak Managerの店舗情報 */
export type PeakManagerCourseObject = {
  __typename?: 'PeakManagerCourseObject';
  /** 所要時間（分） */
  courseMinutes: Scalars['Int'];
  /** 有効期間: 終了日時 */
  endAt?: Maybe<Scalars['ISO8601DateTime']>;
  /** コース名 */
  name: Scalars['String'];
  /** 税抜き価格 */
  noTaxPrice: Scalars['Int'];
  /** PeakManagerのコースカテゴリーID */
  pmCourseCategoryId: Scalars['BigInt'];
  /** PeakManagerのコースID */
  pmCourseId: Scalars['BigInt'];
  /** 税込み価格 */
  price: Scalars['Int'];
  /** コース説明 */
  remarks: Scalars['String'];
  /** 性別フラグ(0: 男性　1: 女性　2: 男女) */
  sex: Scalars['Int'];
  /** 有効期間: 開始日時 */
  startAt?: Maybe<Scalars['ISO8601DateTime']>;
};

/** Peak Managerの店舗情報 */
export type PeakManagerShopObject = {
  __typename?: 'PeakManagerShopObject';
  /** 有効フラグ */
  active?: Maybe<Scalars['Boolean']>;
  /** 住所 */
  address?: Maybe<Scalars['String']>;
  /** 住所2 */
  address2?: Maybe<Scalars['String']>;
  /** 営業時間 */
  businessTimeText?: Maybe<Scalars['String']>;
  /** 店舗コード */
  code?: Maybe<Scalars['String']>;
  /** 企業ID */
  companyId?: Maybe<Scalars['BigInt']>;
  /** PeakManagerの店舗ID */
  id: Scalars['BigInt'];
  /** GoogleMap 緯度 */
  lat?: Maybe<Scalars['Float']>;
  /** GoogleMap 経度 */
  lng?: Maybe<Scalars['Float']>;
  /** 店舗名 */
  name?: Maybe<Scalars['String']>;
  /** 郵便番号 */
  postCode?: Maybe<Scalars['String']>;
  /** 都道府県 */
  prefectureName?: Maybe<Scalars['String']>;
  /** 店舗写真 */
  shopImageUrl?: Maybe<Scalars['String']>;
  /** 電話番号 */
  tel?: Maybe<Scalars['String']>;
};

/** カテゴリーマスタ(PMをベースにしている。予約時に用いる) */
export type PmCourseCategoryObject = {
  __typename?: 'PmCourseCategoryObject';
  /** コース */
  courses: Array<CourseObject>;
  /** 画像URL */
  imageUrl?: Maybe<Scalars['String']>;
  /** オプションかどうか */
  isOption: Scalars['Boolean'];
  /** カテゴリー名 */
  name: Scalars['String'];
  /** コースオプション */
  options: Array<CourseOptionObject>;
  /** 本部指定の親カテゴリID */
  parentCategoryId?: Maybe<Scalars['BigInt']>;
  /** PeakManagerのカテゴリーID */
  pmCourseCategoryId: Scalars['BigInt'];
  /** カテゴリー説明 */
  remarks: Scalars['String'];
};

export const PmCustomerStatusEnum = {
  /** PM登録ありパスあり */
  IsAbleToLogin: 'is_able_to_login',
  /** PM登録なし */
  NotFound: 'not_found',
  /** PM登録ありパスなし */
  Unauthenticated: 'unauthenticated',
  /** その他（例外） */
  Unknown: 'unknown'
} as const;

export type PmCustomerStatusEnum = typeof PmCustomerStatusEnum[keyof typeof PmCustomerStatusEnum];
export type PrefectureAreaObject = {
  __typename?: 'PrefectureAreaObject';
  id: Scalars['Int'];
  name: Scalars['String'];
  prefectures: Array<PrefectureObject>;
  prefecturesHaveShops: Array<PrefectureObject>;
};


export type PrefectureAreaObjectPrefecturesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isHaveShops?: InputMaybe<Scalars['Boolean']>;
};

export type PrefectureObject = {
  __typename?: 'PrefectureObject';
  brandGroups: Array<BrandGroupObject>;
  cities: CityObjectWithKaminariPagination;
  courseGenres: Array<CourseGenreObject>;
  id: Scalars['Int'];
  name: Scalars['String'];
  /** こだわり */
  particularConditions: Array<ParticularConditionObject>;
  prefectureArea: PrefectureAreaObject;
  railroadLines: Array<RailroadLineObject>;
  railroadStations: RailroadStationObjectWithKaminariPagination;
  shopCount: Scalars['Int'];
  shops: ShopObjectWithKaminariPagination;
  sortNo: Scalars['Int'];
};


export type PrefectureObjectBrandGroupsArgs = {
  isHaveShops?: InputMaybe<Scalars['Boolean']>;
};


export type PrefectureObjectCitiesArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isDistinctByCityCode?: InputMaybe<Scalars['Boolean']>;
  isHaveShops?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  per?: InputMaybe<Scalars['Int']>;
};


export type PrefectureObjectCourseGenresArgs = {
  isHaveShops?: InputMaybe<Scalars['Boolean']>;
};


export type PrefectureObjectParticularConditionsArgs = {
  isHaveShops?: InputMaybe<Scalars['Boolean']>;
};


export type PrefectureObjectRailroadLinesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isHaveShops?: InputMaybe<Scalars['Boolean']>;
};


export type PrefectureObjectRailroadStationsArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isHaveShops?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  per?: InputMaybe<Scalars['Int']>;
};

export type Query = {
  __typename?: 'Query';
  /** 全てのバナーを取得します */
  banners: Array<BannerObject>;
  /** 指定したIDのブログ記事を一件返却する */
  blog?: Maybe<BlogObject>;
  /** 与えられたパラメーターでブログ一覧を取得します。 */
  blogs: BlogObjectWithKaminariPagination;
  /** キャンセル理由の選択肢を取得します。 */
  bookingCancelType: Array<BookingCancelTypeObject>;
  /** カスタマーIDから予約履歴を取得します */
  bookingHistories: BookingHistoryObjectWithKaminariPagination;
  /** ブランドIDでブランドを取得します。 */
  brand: BrandObject;
  /** ブランドグループIDでブランドグループを取得します。 */
  brandGroup?: Maybe<BrandGroupObject>;
  /** ブランドグループを取得します。 */
  brandGroups?: Maybe<Array<BrandGroupObject>>;
  /** Cityリストを取得します。 */
  cities: CityObjectWithKaminariPagination;
  /** コラムIDからコラムを取得します。 */
  column?: Maybe<ColumnObject>;
  /** コラム一覧を取得します。 */
  columns: ColumnObjectWithKaminariPagination;
  /** 与えられたパラメータで検索された店舗数を返却します */
  countOfShops: CountOfShopObject;
  currentCustomer?: Maybe<CustomerObject>;
  /** カスタマーIDからカード情報を取得します。 */
  customerCardInfo: CustomerCardInfoObject;
  /** カスタマーIDからチャージ履歴を取得します。 */
  customerChargeHistories: Array<CustomerChargeHistoryObject>;
  /** カスタマーIDから回数券情報を取得します。 */
  customerCouponInfo: CustomerCouponInfoObject;
  /** お知らせIDからお知らせを取得します。 */
  customerInformation?: Maybe<CustomerInformationObject>;
  /** ニュース一覧を取得します。 */
  customerInformations: CustomerInformationObjectWithKaminariPagination;
  /** カスタマーIDから本部・店舗のメール受信設定を取得します。 */
  customerMailMagazineSettings: CustomerMailMagazineSettingsObject;
  /** カスタマーIDからポイント履歴を取得します。 */
  customerPointHistories: Array<CustomerPointHistoryObject>;
  /** カスタマーIDからポイント情報、チャージの情報を取得します */
  customerPointsAndCharges: CustomerPointsAndChargesObject;
  /** 各マスタデータを取得します。 */
  master: MasterObject;
  /** PM店舗IDからPM APIのコースカテゴリー一覧を取得します。 */
  peakManagerCourseCategories?: Maybe<Array<PeakManagerCourseCategoryObject>>;
  /** PM店舗IDからPM APIの店舗を取得します。 */
  peakManagerShop?: Maybe<PeakManagerShopObject>;
  prefectureAreas: Array<PrefectureAreaObject>;
  /** 都道府県リストを取得します。 */
  prefectures: Array<PrefectureObject>;
  /** 路線を一覧を取得します。 */
  railroadLines: Array<RailroadLineObject>;
  /** 駅一覧を取得します。 */
  railroadStations: RailroadStationObjectWithKaminariPagination;
  /** リラクDBから指定したIDのブログ記事を一件返却する */
  rerakuBlog?: Maybe<RerakuBlogObject>;
  /** 与えられたパラメーターでリラクDBからブログ一覧を取得します。 */
  rerakuBlogs: RerakuBlogObjectWithKaminariPagination;
  /** 店舗IDから店舗を取得します。 */
  rerakuCourseCategories: Array<RerakuCourseCategoryObject>;
  /** 店舗IDから店舗を取得します。 */
  shop?: Maybe<ShopObject>;
  /** 店舗に紐づく都道府県、路線などを返却します */
  shopConditionRelations: ShopConditionRelationsObject;
  /** 店舗検索に利用する検索パラメータを取得します。 */
  shopSearchConditions: ShopSearchConditionsObject;
  /** 与えられたパラメータで店舗リストを取得します。 */
  shops: ShopObjectWithKaminariPagination;
  /** スタッフ一覧を取得します。 */
  staffs: Array<StaffObject>;
  /** 空き枠取得 */
  timeTables: TimeTableObject;
};


export type QueryBlogArgs = {
  shopSlug: Scalars['String'];
  wpId: Scalars['Int'];
};


export type QueryBlogsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  per?: InputMaybe<Scalars['Int']>;
  publishedAt?: InputMaybe<Scalars['String']>;
  shopSlug?: InputMaybe<Scalars['String']>;
};


export type QueryBookingHistoriesArgs = {
  currentPage?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
};


export type QueryBrandArgs = {
  id: Scalars['ID'];
};


export type QueryBrandGroupArgs = {
  id?: InputMaybe<Scalars['ID']>;
  urlWord?: InputMaybe<Scalars['String']>;
};


export type QueryCitiesArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isDistinctByCityCode?: InputMaybe<Scalars['Boolean']>;
  isHaveShops?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  per?: InputMaybe<Scalars['Int']>;
  prefectureId?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<Scalars['String']>;
};


export type QueryColumnArgs = {
  displayId: Scalars['String'];
};


export type QueryColumnsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  per?: InputMaybe<Scalars['Int']>;
};


export type QueryCountOfShopsArgs = {
  cityIds?: InputMaybe<Array<Scalars['Int']>>;
  courseCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
  courseGenreIds?: InputMaybe<Array<Scalars['Int']>>;
  currentLocation?: InputMaybe<CurrentLocationInput>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isNew?: InputMaybe<Array<Scalars['Boolean']>>;
  lat?: InputMaybe<Scalars['Float']>;
  lng?: InputMaybe<Scalars['Float']>;
  particularConditionIds?: InputMaybe<Array<Scalars['Int']>>;
  pmShopIds?: InputMaybe<Array<Scalars['BigInt']>>;
  prefectureAreaIds?: InputMaybe<Array<Scalars['Int']>>;
  prefectureId?: InputMaybe<Scalars['Int']>;
  prefectureIds?: InputMaybe<Array<Scalars['Int']>>;
  q?: InputMaybe<Scalars['String']>;
  railroadLineIds?: InputMaybe<Array<Scalars['Int']>>;
  railroadStationIds?: InputMaybe<Array<Scalars['Int']>>;
  shopAreaIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryCustomerCardInfoArgs = {
  pmCardId: Scalars['String'];
};


export type QueryCustomerInformationArgs = {
  displayId: Scalars['String'];
};


export type QueryCustomerInformationsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  per?: InputMaybe<Scalars['Int']>;
  tagName?: InputMaybe<Scalars['String']>;
};


export type QueryPeakManagerCourseCategoriesArgs = {
  pmShopId: Scalars['BigInt'];
  withCache?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPeakManagerShopArgs = {
  pmShopId: Scalars['BigInt'];
  withCache?: InputMaybe<Scalars['Boolean']>;
};


export type QueryPrefecturesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isHaveShops?: InputMaybe<Scalars['Boolean']>;
  q?: InputMaybe<Scalars['String']>;
};


export type QueryRailroadLinesArgs = {
  isHaveShops?: InputMaybe<Scalars['Boolean']>;
};


export type QueryRailroadStationsArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isHaveShops?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  per?: InputMaybe<Scalars['Int']>;
  q?: InputMaybe<Scalars['String']>;
};


export type QueryRerakuBlogArgs = {
  displayId: Scalars['String'];
  shopSlug: Scalars['String'];
};


export type QueryRerakuBlogsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  per?: InputMaybe<Scalars['Int']>;
  publishedAt?: InputMaybe<Scalars['String']>;
  shopSlug?: InputMaybe<Scalars['String']>;
};


export type QueryRerakuCourseCategoriesArgs = {
  brandGroupId?: InputMaybe<Scalars['BigInt']>;
  shopId?: InputMaybe<Scalars['BigInt']>;
};


export type QueryShopArgs = {
  id?: InputMaybe<Scalars['Int']>;
  isAllowedAllFetch?: InputMaybe<Scalars['Boolean']>;
  pmShopId?: InputMaybe<Scalars['BigInt']>;
  slug?: InputMaybe<Scalars['String']>;
};


export type QueryShopsArgs = {
  brandGroupIds?: InputMaybe<Array<Scalars['Int']>>;
  cityIds?: InputMaybe<Array<Scalars['Int']>>;
  codes?: InputMaybe<Array<Scalars['String']>>;
  courseCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
  courseGenreIds?: InputMaybe<Array<Scalars['Int']>>;
  currentLocation?: InputMaybe<CurrentLocationInput>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isAllowedAllFetch?: InputMaybe<Scalars['Boolean']>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  isRecentlyOpened?: InputMaybe<Scalars['Boolean']>;
  isRenewal?: InputMaybe<Scalars['Boolean']>;
  numberOfBookableDates?: InputMaybe<Scalars['Int']>;
  page?: InputMaybe<Scalars['Int']>;
  particularConditionIds?: InputMaybe<Array<Scalars['Int']>>;
  per?: InputMaybe<Scalars['Int']>;
  pmShopIds?: InputMaybe<Array<Scalars['BigInt']>>;
  prefectureAreaIds?: InputMaybe<Array<Scalars['Int']>>;
  prefectureId?: InputMaybe<Scalars['Int']>;
  prefectureIds?: InputMaybe<Array<Scalars['Int']>>;
  q?: InputMaybe<Scalars['String']>;
  railroadLineIds?: InputMaybe<Array<Scalars['Int']>>;
  railroadStationIds?: InputMaybe<Array<Scalars['Int']>>;
  shopAreaIds?: InputMaybe<Array<Scalars['Int']>>;
};


export type QueryStaffsArgs = {
  pmShopId: Scalars['BigInt'];
};


export type QueryTimeTablesArgs = {
  courses: Array<BookingCourseInput>;
  mockType?: InputMaybe<Scalars['String']>;
  pmShopId: Scalars['BigInt'];
  staffId?: InputMaybe<Scalars['BigInt']>;
  staffSexId?: InputMaybe<Scalars['Int']>;
  startDate?: InputMaybe<Scalars['String']>;
  startTime?: InputMaybe<Scalars['String']>;
  viewDay?: InputMaybe<Scalars['Int']>;
};

/** 鉄道会社 */
export type RailroadCompanyObject = {
  __typename?: 'RailroadCompanyObject';
  /** 鉄道会社種別 */
  companyType: RailroadCompanyTypeEnum;
  /** 鉄道会社名正式名称 */
  formalName: Scalars['String'];
  /** 鉄道会社ID */
  id: Scalars['Int'];
  /** 鉄道会社名 */
  name: Scalars['String'];
  /** 鉄道会社名カナ */
  nameKana: Scalars['String'];
  /** 鉄道会社表示順番 */
  sortNo: Scalars['Int'];
};

export const RailroadCompanyTypeEnum = {
  /** JR */
  Jr: 'jr',
  /** 大手私鉄 */
  Major: 'major',
  /** その他 */
  Others: 'others',
  /** 準大手私鉄 */
  SecondTier: 'second_tier'
} as const;

export type RailroadCompanyTypeEnum = typeof RailroadCompanyTypeEnum[keyof typeof RailroadCompanyTypeEnum];
/** 路線 */
export type RailroadLineObject = {
  __typename?: 'RailroadLineObject';
  /** 路線名正式名称 */
  formalName: Scalars['String'];
  /** 路線ID */
  id: Scalars['Int'];
  /** 路線名 */
  name: Scalars['String'];
  /** 路線名カナ */
  nameKana: Scalars['String'];
  /** 鉄道会社 */
  railroadCompany: RailroadCompanyObject;
  /** 鉄道会社ID */
  railroadCompanyId: Scalars['Int'];
  railroadStations: RailroadStationObjectWithKaminariPagination;
  shopCount: Scalars['Int'];
  /** 路線表示順番 */
  sortNo: Scalars['Int'];
};


/** 路線 */
export type RailroadLineObjectRailroadStationsArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isHaveShops?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  per?: InputMaybe<Scalars['Int']>;
  prefectureId?: InputMaybe<Scalars['Int']>;
};

/** 駅情報 */
export type RailroadStationObject = {
  __typename?: 'RailroadStationObject';
  /** 住所 */
  address: Scalars['String'];
  /** 駅ID */
  id: Scalars['Int'];
  /** 駅名 */
  name: Scalars['String'];
  /** 郵便番号ID */
  postalCode: Scalars['String'];
  /** 都道府県ID */
  prefectureId: Scalars['Int'];
  /** 路線 */
  railroadLine: RailroadLineObject;
  /** 路線ID */
  railroadLineId: Scalars['Int'];
  shopCount: Scalars['Int'];
  /** 並び順 */
  sortNo: Scalars['String'];
};

export type RailroadStationObjectWithKaminariPagination = {
  __typename?: 'RailroadStationObjectWithKaminariPagination';
  items: Array<RailroadStationObject>;
  pageInfo: KaminariPageInfoObject;
};

/** 店舗のおすすめコース */
export type RecommendedCourseObject = {
  __typename?: 'RecommendedCourseObject';
  /** 各店毎のメニュー */
  course: CourseObject;
  /** 当日予約フラグ */
  isBookable: Scalars['Boolean'];
};

/** リラクDBブログ情報 */
export type RerakuBlogObject = {
  __typename?: 'RerakuBlogObject';
  /** ブログ本文 */
  content: Scalars['String'];
  /** 表示用ブログID */
  displayId: Scalars['String'];
  /** アイキャッチ画像 */
  eyeCatchingImage?: Maybe<Scalars['String']>;
  /** 店舗予約可能フラグ */
  isShopBookable: Scalars['Boolean'];
  /** 掲載開始日 */
  publishedStartAt: Scalars['ISO8601DateTime'];
  /** 店舗名 */
  shopName: Scalars['String'];
  /** ブログ投稿店舗のスラッグ */
  shopSlug: Scalars['String'];
  /** 店舗電話番号 */
  shopTel?: Maybe<Scalars['String']>;
  /** タイトル */
  title?: Maybe<Scalars['String']>;
};

export type RerakuBlogObjectWithKaminariPagination = {
  __typename?: 'RerakuBlogObjectWithKaminariPagination';
  items: Array<RerakuBlogObject>;
  pageInfo: KaminariPageInfoObject;
};

/** リラクDBコースカテゴリーマスタ（店舗詳細画面で用いる） */
export type RerakuCourseCategoryObject = {
  __typename?: 'RerakuCourseCategoryObject';
  /** 対応可能性別フラグ(男性, 女性, 男女) */
  availableSexType: AvailableSexTypeEnum;
  /** コースカテゴリーID */
  courseCategoryId: Scalars['Int'];
  /** コース */
  courses: Array<RerakuCourseObject>;
  /** コースカテゴリの画像URL */
  imageUrl: Scalars['String'];
  /** コースカテゴリーオプションフラグ */
  isOption: Scalars['Boolean'];
  /** カテゴリ名 */
  name: Scalars['String'];
  /** コースカテゴリー説明 */
  remarks: Scalars['String'];
  /** コースカテゴリー順番 */
  sortNo: Scalars['Int'];
};

/** リラクDB コースマスタ (コース・セット・オプションのマスタ)  */
export type RerakuCourseObject = {
  __typename?: 'RerakuCourseObject';
  /** rerakuのコースカテゴリID */
  courseCategoryId?: Maybe<Scalars['Int']>;
  /** rerakuのコースID */
  courseId?: Maybe<Scalars['Int']>;
  /** 所要時間（分） */
  courseMinutes: Scalars['Int'];
  /** コース名 */
  name: Scalars['String'];
  /** コース説明補足 */
  note?: Maybe<Scalars['String']>;
  /** 税込み価格 */
  price: Scalars['Int'];
  /** コース説明 */
  remarks: Scalars['String'];
};

/** パスワードリセット用引数 */
export type ResetPasswordInput = {
  /** 認証トークン */
  authenticationToken?: InputMaybe<Scalars['String']>;
  /** メールアドレス */
  email?: InputMaybe<Scalars['String']>;
  /** パスワード */
  password?: InputMaybe<Scalars['String']>;
  /** パスワード(確認用) */
  passwordConfirmation?: InputMaybe<Scalars['String']>;
  /** 電話番号 */
  tel?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of ResetPasswordInputMutation */
export type ResetPasswordInputMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  params: ResetPasswordInputParams;
};

/** Autogenerated return type of ResetPasswordInputMutation */
export type ResetPasswordInputMutationPayload = {
  __typename?: 'ResetPasswordInputMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** PMカスタマーID */
  pmCustomerId?: Maybe<Scalars['BigInt']>;
  /** パスワードリセット結果 */
  result: Scalars['Boolean'];
};

export type ResetPasswordInputParams = {
  /** パスワードリセット */
  resetPasswordParams: ResetPasswordInput;
};

/** 店舗予約可能日程 */
export type ShopBookableDateObject = {
  __typename?: 'ShopBookableDateObject';
  /** 日程 */
  date: Scalars['ISO8601Date'];
  /** 予約可能か */
  isBookable: Scalars['Boolean'];
};

/** 店舗に紐づく検索条件 */
export type ShopConditionRelationsObject = {
  __typename?: 'ShopConditionRelationsObject';
  /** コースカテゴリ */
  courseCategories: Array<RerakuCourseCategoryObject>;
  /** コースジャンル */
  courseGenres: Array<CourseGenreObject>;
  /** 都道府県エリア */
  prefectureAreas: Array<PrefectureAreaObject>;
  /** 都道府県 */
  prefectures: Array<PrefectureObject>;
  /** 路線 */
  railroadLines: Array<RailroadLineObject>;
};


/** 店舗に紐づく検索条件 */
export type ShopConditionRelationsObjectCourseCategoriesArgs = {
  isHaveShops?: InputMaybe<Scalars['Boolean']>;
};


/** 店舗に紐づく検索条件 */
export type ShopConditionRelationsObjectCourseGenresArgs = {
  isHaveShops?: InputMaybe<Scalars['Boolean']>;
};


/** 店舗に紐づく検索条件 */
export type ShopConditionRelationsObjectPrefecturesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isHaveShops?: InputMaybe<Scalars['Boolean']>;
};


/** 店舗に紐づく検索条件 */
export type ShopConditionRelationsObjectRailroadLinesArgs = {
  isHaveShops?: InputMaybe<Scalars['Boolean']>;
  isHaveShopsInGroupCode?: InputMaybe<Scalars['Boolean']>;
};

/** 店舗登録内容 */
export type ShopCreateInput = {
  /** 店舗名 */
  name?: InputMaybe<Scalars['String']>;
  /** PM店舗コード */
  pmShopCode?: InputMaybe<Scalars['String']>;
  /** PM店舗ID */
  pmShopId?: InputMaybe<Scalars['BigInt']>;
  /** Slug */
  slug?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of ShopCreateInputMutation */
export type ShopCreateInputMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  params: ShopCreateParams;
};

/** Autogenerated return type of ShopCreateInputMutation */
export type ShopCreateInputMutationPayload = {
  __typename?: 'ShopCreateInputMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** 作成結果 */
  result: Scalars['Boolean'];
  /** 作成情報 */
  shop?: Maybe<ShopObject>;
};

export type ShopCreateParams = {
  /** 店舗登録内容 */
  shopCreateInput: ShopCreateInput;
};

/** 店舗情報 */
export type ShopImageObject = {
  __typename?: 'ShopImageObject';
  /** 画像説明 */
  alt?: Maybe<Scalars['String']>;
  /** 画像ID */
  imageId: Scalars['Int'];
  /** 並び順 */
  sortNo: Scalars['Int'];
  /** 画像の種類 */
  type: Scalars['String'];
  valiantImageUrls: ValiantImagesObject;
};

/** 店舗情報 */
export type ShopImageUpdateInput = {
  /** 画像説明 */
  alt?: InputMaybe<Scalars['String']>;
  /** 画像ID */
  imageId?: InputMaybe<Scalars['Int']>;
  /** 並び順 */
  sortNo?: InputMaybe<Scalars['Int']>;
};

/** 店舗情報 */
export type ShopObject = {
  __typename?: 'ShopObject';
  /** リラクDBアクセス */
  access?: Maybe<Scalars['String']>;
  /** 住所 */
  address?: Maybe<Scalars['String']>;
  /** 住所2 */
  address2?: Maybe<Scalars['String']>;
  /** 入館料に関する記載 */
  admissionFeeText?: Maybe<Scalars['String']>;
  blogs: BlogObjectWithKaminariPagination;
  /** 予約可能日程 */
  bookableDates?: Maybe<Array<ShopBookableDateObject>>;
  /** ブランド */
  brand?: Maybe<BrandObject>;
  /** 営業開始日 */
  businessOpeningDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** 営業時間 */
  businessTimeText?: Maybe<Scalars['String']>;
  /** リラクカードのコード */
  cardCode?: Maybe<Scalars['String']>;
  /** 市区町村 */
  city?: Maybe<CityObject>;
  /** 閉店日 */
  closingDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** 店舗コード */
  code?: Maybe<Scalars['String']>;
  /** 企業ID（多分不要だけどフロント側にも影響するのでいったん削除保留） */
  companyId?: Maybe<Scalars['Int']>;
  /** コースジャンル（店舗検索用） */
  courseGenres: Array<CourseGenreObject>;
  /** 現在地からの距離 */
  distance?: Maybe<Scalars['Float']>;
  /** 住所まとめ */
  fullAddress: Scalars['String'];
  /** 最寄り駅まとめ */
  fullStations: Array<Scalars['String']>;
  /** 業務委託スタッフ所属店舗フラグ */
  hasOutsourcedStaff: Scalars['Boolean'];
  /** 店舗ID */
  id: Scalars['Int'];
  /** 店舗画像 */
  images: Array<ShopImageObject>;
  /** 予約可能フラグ */
  isBookable: Scalars['Boolean'];
  /** 新店フラグ */
  isNew?: Maybe<Scalars['Boolean']>;
  /** Re.Ra.Ku PAYの利用可否 */
  isPayAvailable: Scalars['Boolean'];
  /** PMのActiveフラグ */
  isPmActive: Scalars['Boolean'];
  /** 新店あるいはリニューアル店フラグ */
  isRecentlyOpened?: Maybe<Scalars['Boolean']>;
  /** リニューアル店フラグ */
  isRenewal?: Maybe<Scalars['Boolean']>;
  /** 入館料が必要か */
  isRequiredAdmissionFee: Scalars['Boolean'];
  /** リラクDB予約可能かどうか */
  isWebBookable: Scalars['Boolean'];
  /** 緯度 */
  lat?: Maybe<Scalars['Float']>;
  /** 経度 */
  lng?: Maybe<Scalars['Float']>;
  /** 店舗からのメッセージ（HTML形式） */
  messageFromShopHtml?: Maybe<Scalars['String']>;
  /** 店舗名 */
  name: Scalars['String'];
  /** 最寄り駅 */
  nearestRailroadStations: Array<NearestRailroadStationObject>;
  /** 近隣店舗 */
  nearestShops: ShopObjectWithKaminariPagination;
  /** 備考欄 */
  note?: Maybe<Scalars['String']>;
  /** 開店日 */
  openingDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** こだわり */
  particularConditions: Array<ParticularConditionObject>;
  /** 支払い方法 */
  paymentMethods: Array<PaymentMethodObject>;
  /** PMから取得するコースカテゴリー（pm_shop_idに紐づかない店舗は空配列） */
  pmCourseCategories: Array<PmCourseCategoryObject>;
  /** PeakManagerの店舗ID */
  pmShopId?: Maybe<Scalars['BigInt']>;
  /** 郵便番号 */
  postCode?: Maybe<Scalars['String']>;
  /** 都道府県 */
  prefecture?: Maybe<PrefectureObject>;
  /** 都道府県 */
  prefectureName?: Maybe<Scalars['String']>;
  /** 店舗公開終了時間 */
  publishedEndAt?: Maybe<Scalars['String']>;
  /** 店舗公開時間 */
  publishedStartAt?: Maybe<Scalars['String']>;
  /** 駅 */
  railroadStations: Array<RailroadStationObject>;
  /** 店舗のおすすめコース */
  recommendedCourses: Array<RecommendedCourseObject>;
  /** 採用媒体のURL */
  recruitUrl?: Maybe<Scalars['String']>;
  /** リニューアルオープン日 */
  renewalOpeningDate?: Maybe<Scalars['ISO8601DateTime']>;
  /** リラクDB住所1 */
  rerakuAddress?: Maybe<Scalars['String']>;
  /** リラクDB住所2 */
  rerakuAddress2?: Maybe<Scalars['String']>;
  rerakuBlogs: RerakuBlogObjectWithKaminariPagination;
  /** reraku dbのコースカテゴリー */
  rerakuCourseCategories: Array<RerakuCourseCategoryObject>;
  /** リラクDBの緯度 */
  rerakuLat?: Maybe<Scalars['Float']>;
  /** リラクDBの経度 */
  rerakuLng?: Maybe<Scalars['Float']>;
  /** リラク郵便番号 */
  rerakuPostCode?: Maybe<Scalars['String']>;
  /** リラク電話番号 */
  rerakuTel?: Maybe<Scalars['String']>;
  /** 検索用キーワード */
  searchKeyword?: Maybe<Scalars['String']>;
  /** 周辺 */
  shopAreas: Array<ShopShopAreaObject>;
  /** （男女）指名予約設定（PMと接続していない場合はnull返却） */
  shopSettings?: Maybe<ShopSettingsObject>;
  /** 店舗Slug */
  slug: Scalars['String'];
  /** スタッフ */
  staffs: Array<StaffObject>;
  /** 店舗公開状態 */
  status: ShopStatusEnum;
  /** 電話番号 */
  tel?: Maybe<Scalars['String']>;
  /** 営業時間(テキスト) */
  workingTime?: Maybe<Scalars['String']>;
  /** WP店舗ID */
  wpAuthorId?: Maybe<Scalars['Int']>;
};


/** 店舗情報 */
export type ShopObjectBlogsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  per?: InputMaybe<Scalars['Int']>;
};


/** 店舗情報 */
export type ShopObjectRerakuBlogsArgs = {
  page?: InputMaybe<Scalars['Int']>;
  per?: InputMaybe<Scalars['Int']>;
};

export type ShopObjectWithKaminariPagination = {
  __typename?: 'ShopObjectWithKaminariPagination';
  items: Array<ShopObject>;
  pageInfo: KaminariPageInfoObject;
};

/** 店舗検索に必要な情報 */
export type ShopSearchConditionsObject = {
  __typename?: 'ShopSearchConditionsObject';
  cities: CityObjectWithKaminariPagination;
  /** コースジャンル */
  courseGenres: Array<CourseGenreObject>;
  /** こだわり */
  particularConditions: Array<ParticularConditionObject>;
  /** 都道府県エリア */
  prefectureAreas: Array<PrefectureAreaObject>;
  /** 都道府県 */
  prefectures: Array<PrefectureObject>;
  railroadLines: Array<RailroadLineObject>;
};


/** 店舗検索に必要な情報 */
export type ShopSearchConditionsObjectCitiesArgs = {
  all?: InputMaybe<Scalars['Boolean']>;
  isDistinctByCityCode?: InputMaybe<Scalars['Boolean']>;
  isHaveShops?: InputMaybe<Scalars['Boolean']>;
  page?: InputMaybe<Scalars['Int']>;
  per?: InputMaybe<Scalars['Int']>;
  prefectureId?: InputMaybe<Scalars['Int']>;
  skipLoadData?: InputMaybe<Scalars['Boolean']>;
};


/** 店舗検索に必要な情報 */
export type ShopSearchConditionsObjectCourseGenresArgs = {
  isHaveShops?: InputMaybe<Scalars['Boolean']>;
};


/** 店舗検索に必要な情報 */
export type ShopSearchConditionsObjectParticularConditionsArgs = {
  isHaveShops?: InputMaybe<Scalars['Boolean']>;
};


/** 店舗検索に必要な情報 */
export type ShopSearchConditionsObjectPrefectureAreasArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
};


/** 店舗検索に必要な情報 */
export type ShopSearchConditionsObjectPrefecturesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isHaveShops?: InputMaybe<Scalars['Boolean']>;
};


/** 店舗検索に必要な情報 */
export type ShopSearchConditionsObjectRailroadLinesArgs = {
  ids?: InputMaybe<Array<Scalars['Int']>>;
  isHaveShops?: InputMaybe<Scalars['Boolean']>;
  prefectureId?: InputMaybe<Scalars['Int']>;
  skipLoadData?: InputMaybe<Scalars['Boolean']>;
};

/** 店舗設定状況 */
export type ShopSettingsObject = {
  __typename?: 'ShopSettingsObject';
  /** 店舗が閉店しているかの確認フラグ */
  closed: Scalars['Boolean'];
  /** 女性希望表示フラグ */
  femaleDisplay: Scalars['Boolean'];
  /** 女性希望表示名 */
  femaleDisplayName?: Maybe<Scalars['String']>;
  /** 女性希望料金 */
  femaleNominatePrice?: Maybe<Scalars['Int']>;
  /** 女性希望確認ID, 1：男性希望 2：女性希望 */
  femaleStickId?: Maybe<Scalars['Int']>;
  /** 男女希望指名可能確認フラグ */
  isNominateSexBooking?: Maybe<Scalars['Boolean']>;
  /** 男性希望表示フラグ */
  maleDisplay: Scalars['Boolean'];
  /** 男性希望表示名 */
  maleDisplayName?: Maybe<Scalars['String']>;
  /** 男性希望料金 */
  maleNominatePrice?: Maybe<Scalars['Int']>;
  /** 男性希望確認ID, 1：男性希望 2：女性希望 */
  maleStickId?: Maybe<Scalars['Int']>;
  /** 個人指名料コースID */
  nominateCourseId?: Maybe<Scalars['BigInt']>;
  /** 男女希望指名料コースID */
  nominateSexCourseId?: Maybe<Scalars['BigInt']>;
};

/** エリア */
export type ShopShopAreaObject = {
  __typename?: 'ShopShopAreaObject';
  /** エリア親子関係 */
  ancestry?: Maybe<Scalars['String']>;
  /** エリアに紐づく子要素 */
  children: Array<ShopShopAreaObject>;
  /** エリアID */
  id: Scalars['Int'];
  /** エリア名 */
  name: Scalars['String'];
  /** 順番 */
  sortNo: Scalars['Int'];
};

export const ShopStatusEnum = {
  /** 閉店 */
  Closed: 'closed',
  /** 非公開 */
  Hidden: 'hidden',
  /** 公開 */
  Published: 'published'
} as const;

export type ShopStatusEnum = typeof ShopStatusEnum[keyof typeof ShopStatusEnum];
/** 店舗状況 */
export type ShopStatusObject = {
  __typename?: 'ShopStatusObject';
  /** 名前 */
  text: Scalars['String'];
  /** 値 */
  value: ShopStatusEnum;
};

/** 店舗更新内容 */
export type ShopUpdateInput = {
  /** 店舗アクセス */
  access?: InputMaybe<Scalars['String']>;
  /** 住所1 */
  address?: InputMaybe<Scalars['String']>;
  /** 住所2 */
  address2?: InputMaybe<Scalars['String']>;
  /** 入館料に関する記載 */
  admissionFeeText?: InputMaybe<Scalars['String']>;
  /** ブランドID */
  brandId?: InputMaybe<Scalars['Int']>;
  /** 営業時間 */
  businessTimeText?: InputMaybe<Scalars['String']>;
  /** リラクカードのコード */
  cardCode?: InputMaybe<Scalars['String']>;
  /** 市区町村ID */
  cityId?: InputMaybe<Scalars['Int']>;
  /** 閉店日 */
  closingDate?: InputMaybe<Scalars['String']>;
  /** 店舗詳細のコースIDの配列 */
  courseCategoryIds?: InputMaybe<Array<Scalars['Int']>>;
  /** 検索用のコースジャンルIDの配列 */
  courseGenreIds?: InputMaybe<Array<Scalars['Int']>>;
  /** PMのコースカテゴリーがオプションかどうかの配列 */
  forOptionPmCourseCategoryIds?: InputMaybe<Array<Scalars['BigInt']>>;
  /** 業務委託スタッフ所属店舗か */
  hasOutsourcedStaff?: InputMaybe<Scalars['Boolean']>;
  /** 画像 */
  images?: InputMaybe<Array<ShopImageUpdateInput>>;
  /** Re.Ra.Ku PAYの利用可否 */
  isPayAvailable?: InputMaybe<Scalars['Boolean']>;
  /** 入館料が必要か */
  isRequiredAdmissionFee?: InputMaybe<Scalars['Boolean']>;
  /** リラクDB予約可能か */
  isWebBookable?: InputMaybe<Scalars['Boolean']>;
  /** 緯度 */
  lat?: InputMaybe<Scalars['Float']>;
  /** 経度 */
  lng?: InputMaybe<Scalars['Float']>;
  /** 店舗からのメッセージ（HTML形式） */
  messageFromShopHtml?: InputMaybe<Scalars['String']>;
  /** 店舗名 */
  name?: InputMaybe<Scalars['String']>;
  /** 最寄り駅の配列 */
  nearestRailroadStations?: InputMaybe<Array<NearestRailroadStationInput>>;
  /** 備考欄 */
  note?: InputMaybe<Scalars['String']>;
  /** 開店日 */
  openingDate?: InputMaybe<Scalars['String']>;
  /** こだわりID */
  particularConditionIds?: InputMaybe<Array<Scalars['Int']>>;
  /** 支払い方法ID */
  paymentMethodIds?: InputMaybe<Array<Scalars['Int']>>;
  /** PM店舗コード */
  pmShopCode?: InputMaybe<Scalars['String']>;
  /** PM店舗ID */
  pmShopId?: InputMaybe<Scalars['BigInt']>;
  /** 都道府県ID */
  prefectureId?: InputMaybe<Scalars['Int']>;
  /** 店舗公開終了時間 */
  publishedEndAt?: InputMaybe<Scalars['String']>;
  /** 店舗公開時間 */
  publishedStartAt?: InputMaybe<Scalars['String']>;
  /** 採用媒体のURL */
  recruitUrl?: InputMaybe<Scalars['String']>;
  /** リニューアルオープン日 */
  renewalOpeningDate?: InputMaybe<Scalars['String']>;
  /** フリーワード検索用のキーワード */
  searchKeyword?: InputMaybe<Scalars['String']>;
  /** 地域エリアID */
  shopAreaIds?: InputMaybe<Array<Scalars['Int']>>;
  /** Slug */
  slug?: InputMaybe<Scalars['String']>;
  /** 店舗公開状態 */
  status?: InputMaybe<Scalars['String']>;
  /** 電話番号 */
  tel?: InputMaybe<Scalars['String']>;
  /** WP店舗ID */
  wpAuthorId?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of ShopUpdateInputMutation */
export type ShopUpdateInputMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  params: ShopUpdateParams;
};

/** Autogenerated return type of ShopUpdateInputMutation */
export type ShopUpdateInputMutationPayload = {
  __typename?: 'ShopUpdateInputMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** 更新結果 */
  result: Scalars['Boolean'];
  /** 更新情報 */
  shop?: Maybe<ShopObject>;
};

export type ShopUpdateParams = {
  /** 店舗ID */
  id: Scalars['Int'];
  /** 店舗更新内容 */
  shopUpdateInput: ShopUpdateInput;
};

/** Autogenerated input type of SignUpMutation */
export type SignUpMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  params: SignUpParams;
};

/** Autogenerated return type of SignUpMutation */
export type SignUpMutationPayload = {
  __typename?: 'SignUpMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** 新規登録したカスタマー情報 */
  customer?: Maybe<CustomerObject>;
  /** 新規登録結果 */
  result: Scalars['Boolean'];
};

export type SignUpParams = {
  /** カスタマー新規登録パラメータ */
  customerSignUpParams: CustomerSignUpInput;
};

/** スタッフ情報 */
export type StaffObject = {
  __typename?: 'StaffObject';
  /** 個人指名フラグ */
  canBeNominated: Scalars['Boolean'];
  /** 男女指名フラグ */
  canBeNominatedBySex: Scalars['Boolean'];
  /** 社員番号 */
  code: Scalars['String'];
  /** スタッフ画像のパス */
  imageUrl?: Maybe<Scalars['String']>;
  /** 本日出勤可否 */
  isAvailableToday: Scalars['Boolean'];
  /** スタッフ名 */
  name: Scalars['String'];
  /** ニックネーム */
  nickname: Scalars['String'];
  /** 指名オプション名 */
  nominateOptionName?: Maybe<Scalars['String']>;
  /** 指名料 */
  nominatePrice?: Maybe<Scalars['Int']>;
  /** PMスタッフID */
  pmStaffId: Scalars['BigInt'];
  /** フリーメッセージ */
  remark?: Maybe<Scalars['String']>;
  /** 性別(男性: 0, 女性: 1) */
  sex: Scalars['Int'];
  /** 表示順 */
  sort: Scalars['String'];
};

/** 日別の空き枠 */
export type TimeTableByDateObject = {
  __typename?: 'TimeTableByDateObject';
  /** 空き枠を取得する日付 */
  date: Scalars['String'];
  /** 30分間隔の空き枠 */
  timeTablesByHalfHour: Array<TimeTableByHalfHourObject>;
};

/** 30分単位の空き枠 */
export type TimeTableByHalfHourObject = {
  __typename?: 'TimeTableByHalfHourObject';
  /** 空き枠を取得する30分単位の時間枠 */
  halfHour: Scalars['String'];
  /** 30分単位の空き枠の空き状況ステータス */
  timeTableStatusByHalfHour: TimeTableStatusByHalfHourObject;
};

/** 営業時間 (空き枠の取得範囲) */
export type TimeTableHourRangeObject = {
  __typename?: 'TimeTableHourRangeObject';
  /** 営業終了時間(空き枠検索の範囲の上限) */
  endTime: Scalars['String'];
  /** 営業開始時間(空き枠検索の範囲の下限) */
  startTime: Scalars['String'];
};

/** 空き情報 */
export type TimeTableObject = {
  __typename?: 'TimeTableObject';
  /** 営業時間 (空き枠の取得範囲) */
  timeTableHourRange: TimeTableHourRangeObject;
  /** 空き枠の一覧(日別) */
  timeTablesByDate: Array<TimeTableByDateObject>;
};

/** 30分単位の空き枠のステータス */
export type TimeTableStatusByHalfHourObject = {
  __typename?: 'TimeTableStatusByHalfHourObject';
  /** 30分単位の空き枠ステータス */
  timeTableStatus: TimeTableStatusEnum;
  /** 10分単位の空き枠の空き状況 */
  timeTableStatusesEvery10Minutes: Array<TimeTableStatusEvery10MinutesObject>;
};

export const TimeTableStatusEnum = {
  /** 予約可能(10分単位の枠全て予約可能) */
  Bookable: 'bookable',
  /** 空きなし (10分単位の予約枠が全て埋まっている) */
  NoVacant: 'no_vacant',
  /** 残枠僅少 (10分単位の予約枠のうち、1つまたは2つ予約可能) */
  OnlyAFew: 'only_a_few'
} as const;

export type TimeTableStatusEnum = typeof TimeTableStatusEnum[keyof typeof TimeTableStatusEnum];
/** 10分単位の空き枠のステータス */
export type TimeTableStatusEvery10MinutesObject = {
  __typename?: 'TimeTableStatusEvery10MinutesObject';
  /** 10分単位の時間枠 */
  startTime: Scalars['String'];
  /** 10分単位の空き枠ステータス */
  status: Scalars['Boolean'];
};

export type TimestampInterface = {
  /** 作成日時 */
  createdAt: Scalars['ISO8601DateTime'];
  /** 更新日時 */
  updatedAt: Scalars['ISO8601DateTime'];
};

/** UTMパラメータ */
export type TrackingParameterInput = {
  /** utm_campaign */
  utmCampaign?: InputMaybe<Scalars['String']>;
  /** utm_id */
  utmId?: InputMaybe<Scalars['String']>;
  /** utm_medium */
  utmMedium?: InputMaybe<Scalars['String']>;
  /** utm_source */
  utmSource?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateCustomerEmailMutation */
export type UpdateCustomerEmailMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  params: UpdateCustomerEmailParams;
};

/** Autogenerated return type of UpdateCustomerEmailMutation */
export type UpdateCustomerEmailMutationPayload = {
  __typename?: 'UpdateCustomerEmailMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** 更新後のカスタマー情報 */
  customer?: Maybe<CustomerObject>;
  /** 更新結果 */
  result: Scalars['Boolean'];
};

export type UpdateCustomerEmailParams = {
  /** 認証トークン */
  authenticationToken?: InputMaybe<Scalars['String']>;
  /** テスト用（tel mail check mock） */
  mockType?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of UpdateCustomerMailMagazineSettingsMutation */
export type UpdateCustomerMailMagazineSettingsMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  params: UpdateCustomerMailMagazineSettingsParams;
};

/** Autogenerated return type of UpdateCustomerMailMagazineSettingsMutation */
export type UpdateCustomerMailMagazineSettingsMutationPayload = {
  __typename?: 'UpdateCustomerMailMagazineSettingsMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** 更新後の本部・店舗のメール受信設定 */
  customerMailMagazineSettings?: Maybe<CustomerMailMagazineSettingsObject>;
  /** 更新結果 */
  result: Scalars['Boolean'];
};

export type UpdateCustomerMailMagazineSettingsParams = {
  /** メルマガ設定変更内容 */
  customerMailMagazineSettings?: InputMaybe<CustomerMailMagazineSettingsInput>;
};

/** Autogenerated input type of UpdateCustomerPasswordMutation */
export type UpdateCustomerPasswordMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  params: UpdateCustomerPasswordParams;
};

/** Autogenerated return type of UpdateCustomerPasswordMutation */
export type UpdateCustomerPasswordMutationPayload = {
  __typename?: 'UpdateCustomerPasswordMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** 更新後のカスタマー情報 */
  customer?: Maybe<CustomerObject>;
  /** 更新結果 */
  result: Scalars['Boolean'];
};

export type UpdateCustomerPasswordParams = {
  /** 現在のパスワード */
  currentPassword?: InputMaybe<Scalars['String']>;
  /** 変更後のパスワード */
  password?: InputMaybe<Scalars['String']>;
  /** 変更後のパスワード（確認用） */
  passwordConfirmation?: InputMaybe<Scalars['String']>;
};

/** Autogenerated input type of UpdateCustomerProfileMutation */
export type UpdateCustomerProfileMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  params: UpdateCustomerProfileParams;
};

/** Autogenerated return type of UpdateCustomerProfileMutation */
export type UpdateCustomerProfileMutationPayload = {
  __typename?: 'UpdateCustomerProfileMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** 更新後のカスタマー情報 */
  customer?: Maybe<CustomerObject>;
  /** 更新結果 */
  result: Scalars['Boolean'];
};

export type UpdateCustomerProfileParams = {
  /** 住所1 (市区町村・番地まで) */
  address?: InputMaybe<Scalars['String']>;
  /** 住所2 (建物名・部屋番号など) */
  address2?: InputMaybe<Scalars['String']>;
  /** 生年月日 */
  birthday?: InputMaybe<Scalars['ISO8601Date']>;
  /** DM受け取りフラグ（0: 受け取らない, 1: 受け取る） */
  isEnabledToReceiveDm?: InputMaybe<Scalars['Int']>;
  /** 変更後のカナ */
  nameKana?: InputMaybe<Scalars['String']>;
  /** 郵便番号 */
  postCode?: InputMaybe<Scalars['String']>;
  /** 都道府県ID（PMのものと同一のため、reraku dbのIDでOK） */
  prefectureId?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated input type of UpdateCustomerTelMutation */
export type UpdateCustomerTelMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  params: UpdateCustomerTelParams;
};

/** Autogenerated return type of UpdateCustomerTelMutation */
export type UpdateCustomerTelMutationPayload = {
  __typename?: 'UpdateCustomerTelMutationPayload';
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** 更新後のカスタマー情報 */
  customer?: Maybe<CustomerObject>;
  /** 更新結果 */
  result: Scalars['Boolean'];
};

export type UpdateCustomerTelParams = {
  /** 認証トークン */
  authenticationToken?: InputMaybe<Scalars['String']>;
  /** テスト用（tel mail check mock） */
  mockType?: InputMaybe<Scalars['Int']>;
};

/** 画像のバリエーション */
export type ValiantImageObject = {
  __typename?: 'ValiantImageObject';
  /** 高さ */
  h: Scalars['Int'];
  /** 画像URL */
  url: Scalars['String'];
  /** 幅 */
  w: Scalars['Int'];
};

/** 画像のバリエーション */
export type ValiantImagesObject = {
  __typename?: 'ValiantImagesObject';
  extrasmallsquare: ValiantImageObject;
  large: ValiantImageObject;
  largesquare: ValiantImageObject;
  middle: ValiantImageObject;
  small: ValiantImageObject;
  smallsquare: ValiantImageObject;
  square: ValiantImageObject;
  xlarge: ValiantImageObject;
};

/** Autogenerated input type of ValidateAuthenticationCodeMutation */
export type ValidateAuthenticationCodeMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  params: ValidateAuthenticationCodeMutationParams;
};

export type ValidateAuthenticationCodeMutationParams = {
  /** 認証コード */
  authenticationCode?: InputMaybe<Scalars['String']>;
  /** 認証トークン（認証コードと合わせて認証する） */
  authenticationToken?: InputMaybe<Scalars['String']>;
  /** テスト用（tel mail check mock） */
  mockType?: InputMaybe<Scalars['Int']>;
};

/** Autogenerated return type of ValidateAuthenticationCodeMutation */
export type ValidateAuthenticationCodeMutationPayload = {
  __typename?: 'ValidateAuthenticationCodeMutationPayload';
  /** 認証トークン */
  authenticationToken: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** PM登録済みメールアドレス */
  pmCustomerEmail?: Maybe<Scalars['String']>;
  /** PMカスタマーステータス */
  pmCustomerStatus?: Maybe<PmCustomerStatusEnum>;
  /** PM登録済み電話番号 */
  pmCustomerTel?: Maybe<Scalars['String']>;
  /** トークン有効性チェック実行完了フラグ */
  result: Scalars['Boolean'];
};

/** Autogenerated input type of VerifyTelMutation */
export type VerifyTelMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  params: VerifyTelMutationParams;
};

export type VerifyTelMutationParams = {
  /** 認証する電話番号 */
  tel?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of VerifyTelMutation */
export type VerifyTelMutationPayload = {
  __typename?: 'VerifyTelMutationPayload';
  /** 認証トークン */
  authenticationToken: Scalars['String'];
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** PMカスタマーステータス */
  pmCustomerStatus?: Maybe<PmCustomerStatusEnum>;
  /** 電話番号認証実行完了フラグ */
  result: Scalars['Boolean'];
};

/** Autogenerated input type of VerifyTelOrEmailMutation */
export type VerifyTelOrEmailMutationInput = {
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: InputMaybe<Scalars['String']>;
  params: VerifyTelOrEmailMutationParams;
};

export type VerifyTelOrEmailMutationParams = {
  /** 認証コードタイプ */
  authenticationKind?: InputMaybe<AuthenticationKindEnum>;
  /** mockタイプ(tel mail checkテスト用) */
  mockType?: InputMaybe<Scalars['Int']>;
  /** tel認証の際に必要なカナ */
  nameKana?: InputMaybe<Scalars['String']>;
  /** 認証するメールアドレスor電話番号 */
  telOrEmail?: InputMaybe<Scalars['String']>;
};

/** Autogenerated return type of VerifyTelOrEmailMutation */
export type VerifyTelOrEmailMutationPayload = {
  __typename?: 'VerifyTelOrEmailMutationPayload';
  /** 認証トークン */
  authenticationToken?: Maybe<Scalars['String']>;
  /** A unique identifier for the client performing the mutation. */
  clientMutationId?: Maybe<Scalars['String']>;
  /** 認証実行完了フラグ */
  result: Scalars['Boolean'];
};

export type BookingCancelMutationVariables = Exact<{
  bookingCancelInput: BookingCancelMutationInput;
}>;


export type BookingCancelMutation = { __typename?: 'Mutation', bookingCancel: { __typename?: 'BookingCancelMutationPayload', result: boolean, bookingCancelled: { __typename?: 'BookingCancelObject', status: boolean } } };

export type BookingConfirmMutationVariables = Exact<{
  bookingConfirmInput: BookingConfirmMutationInput;
}>;


export type BookingConfirmMutation = { __typename?: 'Mutation', bookingConfirm: { __typename?: 'BookingConfirmMutationPayload', result: boolean, bookingConfirmInfo?: { __typename?: 'BookingConfirmObject', isBookable: boolean, totalPrice: number, hasCourseIdsChanged: boolean, bookingMenu: Array<{ __typename?: 'BookingCourseCategoryObject', pmCourseCategoryId: any, name: string, courses: Array<{ __typename?: 'BookingCourseObject', pmCourseId: any, name: string, price: number }>, options: Array<{ __typename?: 'BookingCourseObject', pmCourseId: any, name: string, price: number }> }>, nominateInfo?: { __typename?: 'BookingConfirmNominateInfoObject', courseOptionId?: any | null, courseOptionName?: string | null, price?: number | null, noTaxPrice?: number | null } | null, courseParams: Array<{ __typename?: 'BookingCourseParamsObject', pmCourseCategoryId?: any | null, pmCourseId?: any | null, pmCourseOptionIds?: Array<any> | null }> } | null } };

export type BookingGuestInputMutationVariables = Exact<{
  bookingGuestInput: BookingGuestInputMutationInput;
}>;


export type BookingGuestInputMutation = { __typename?: 'Mutation', bookingGuestInput: { __typename?: 'BookingGuestInputMutationPayload', result: boolean, booking?: { __typename?: 'BookingCompletedObject', pmShopId?: any | null, pmBookingId: any, pmCustomerId?: any | null, bookingMenu?: Array<{ __typename?: 'BookingCourseCategoryObject', pmCourseCategoryId: any, courses: Array<{ __typename?: 'BookingCourseObject', pmCourseId: any, name: string, price: number, noTaxPrice: number }>, options: Array<{ __typename?: 'BookingCourseObject', pmCourseId: any, name: string, price: number, noTaxPrice: number }> }> | null } | null } };

export type BookingInputMutationVariables = Exact<{
  bookingInput: BookingInputMutationInput;
}>;


export type BookingInputMutation = { __typename?: 'Mutation', bookingInput: { __typename?: 'BookingInputMutationPayload', result: boolean, booking?: { __typename?: 'BookingCompletedObject', pmShopId?: any | null, pmBookingId: any, pmCustomerId?: any | null, bookingMenu?: Array<{ __typename?: 'BookingCourseCategoryObject', pmCourseCategoryId: any, courses: Array<{ __typename?: 'BookingCourseObject', pmCourseId: any, name: string, price: number, noTaxPrice: number }>, options: Array<{ __typename?: 'BookingCourseObject', pmCourseId: any, name: string, price: number, noTaxPrice: number }> }> | null } | null } };

export type CustomerCheckStatusMutationVariables = Exact<{
  checkPmCustomerStatusMutationInput: CheckPmCustomerStatusMutationInput;
}>;


export type CustomerCheckStatusMutation = { __typename?: 'Mutation', customerCheckPmCustomerStatus: { __typename?: 'CheckPmCustomerStatusMutationPayload', pmCustomerStatus: PmCustomerStatusEnum, result: boolean } };

export type CustomerLoginMutationVariables = Exact<{
  loginByTelOrEmailInput: LoginByTelOrEmailMutationInput;
}>;


export type CustomerLoginMutation = { __typename?: 'Mutation', customerLogin: { __typename?: 'LoginByTelOrEmailMutationPayload', result: boolean, customer?: { __typename?: 'CustomerObject', id: number, pmCustomerId: any, pmShopId: any, name: string, nameKana: string, tel?: string | null, email?: string | null, birthday?: any | null, sex: number, isNeededShopMail: number } | null } };

export type CustomerLogoutMutationVariables = Exact<{ [key: string]: never; }>;


export type CustomerLogoutMutation = { __typename?: 'Mutation', customerLogout: { __typename?: 'LogoutMutationPayload', result: boolean } };

export type CustomerResetPasswordMutationVariables = Exact<{
  resetPasswordInput: ResetPasswordInputMutationInput;
}>;


export type CustomerResetPasswordMutation = { __typename?: 'Mutation', customerResetPassword: { __typename?: 'ResetPasswordInputMutationPayload', result: boolean } };

export type CustomerSignUpMutationVariables = Exact<{
  signUpMutationInput: SignUpMutationInput;
}>;


export type CustomerSignUpMutation = { __typename?: 'Mutation', customerSignUp: { __typename?: 'SignUpMutationPayload', result: boolean, customer?: { __typename?: 'CustomerObject', id: number, pmCustomerId: any, pmShopId: any, name: string, nameKana: string, tel?: string | null, email?: string | null, birthday?: any | null, sex: number, isNeededShopMail: number } | null } };

export type CustomerUpdateEmailMutationVariables = Exact<{
  updateEmailMutationInput: UpdateCustomerEmailMutationInput;
}>;


export type CustomerUpdateEmailMutation = { __typename?: 'Mutation', customerUpdateEmail: { __typename?: 'UpdateCustomerEmailMutationPayload', result: boolean } };

export type CustomerUpdateMailMagazineSettingsMutationVariables = Exact<{
  updateCustomerMailMagazineSettingsMutationInput: UpdateCustomerMailMagazineSettingsMutationInput;
}>;


export type CustomerUpdateMailMagazineSettingsMutation = { __typename?: 'Mutation', customerUpdateMailMagazineSettings: { __typename?: 'UpdateCustomerMailMagazineSettingsMutationPayload', result: boolean } };

export type CustomerUpdatePasswordMutationVariables = Exact<{
  updateCustomerPasswordInput: UpdateCustomerPasswordMutationInput;
}>;


export type CustomerUpdatePasswordMutation = { __typename?: 'Mutation', customerUpdatePassword: { __typename?: 'UpdateCustomerPasswordMutationPayload', result: boolean } };

export type CustomerUpdateProfileMutationVariables = Exact<{
  updateProfileMutationInput: UpdateCustomerProfileMutationInput;
}>;


export type CustomerUpdateProfileMutation = { __typename?: 'Mutation', customerUpdateProfile: { __typename?: 'UpdateCustomerProfileMutationPayload', result: boolean } };

export type CustomerUpdateTelMutationVariables = Exact<{
  updateTelMutationInput: UpdateCustomerTelMutationInput;
}>;


export type CustomerUpdateTelMutation = { __typename?: 'Mutation', customerUpdateTel: { __typename?: 'UpdateCustomerTelMutationPayload', result: boolean } };

export type CustomerValidateAuthenticationCodeMutationVariables = Exact<{
  validateAuthenticationCodeMutationInput: ValidateAuthenticationCodeMutationInput;
}>;


export type CustomerValidateAuthenticationCodeMutation = { __typename?: 'Mutation', customerValidateAuthenticationCode: { __typename?: 'ValidateAuthenticationCodeMutationPayload', result: boolean, pmCustomerStatus?: PmCustomerStatusEnum | null, pmCustomerEmail?: string | null, pmCustomerTel?: string | null, authenticationToken: string } };

export type CustomerVerifyTelMutationVariables = Exact<{
  verifyTelMutationInput: VerifyTelMutationInput;
}>;


export type CustomerVerifyTelMutation = { __typename?: 'Mutation', customerVerifyTel: { __typename?: 'VerifyTelMutationPayload', result: boolean, authenticationToken: string, pmCustomerStatus?: PmCustomerStatusEnum | null } };

export type CustomerVerifyTelOrEmailMutationVariables = Exact<{
  verifyTelOrEmailMutationInput: VerifyTelOrEmailMutationInput;
}>;


export type CustomerVerifyTelOrEmailMutation = { __typename?: 'Mutation', customerVerifyTelOrEmail: { __typename?: 'VerifyTelOrEmailMutationPayload', result: boolean, authenticationToken?: string | null } };

export type BannersQueryVariables = Exact<{ [key: string]: never; }>;


export type BannersQuery = { __typename?: 'Query', banners: Array<{ __typename?: 'BannerObject', id: number, altText: string, spImage: string, pcImage: string, imageLink: string, publishedStartAt?: any | null }> };

export type BookingCancelTypeQueryVariables = Exact<{ [key: string]: never; }>;


export type BookingCancelTypeQuery = { __typename?: 'Query', bookingCancelType: Array<{ __typename?: 'BookingCancelTypeObject', text: string, value: BookingCancelTypeEnum }> };

export type BookingHistoriesQueryVariables = Exact<{
  page: Scalars['Int'];
}>;


export type BookingHistoriesQuery = { __typename?: 'Query', bookingHistories: { __typename?: 'BookingHistoryObjectWithKaminariPagination', items: Array<{ __typename?: 'BookingHistoryObject', startTime: string, shopName: string, shopSlug?: string | null, shopTel: string, staffName: Array<string>, courseName: Array<string>, price: number, cancelledDate?: string | null, isCancellable: boolean, isShopClosed: boolean, isAlreadyTreated: boolean, isDesignated: boolean, isCourseBookable: boolean, designedStaffId?: any | null, pmShopId: any, pmBookingId: any, options: Array<string>, bookingHistoryCourses: Array<{ __typename?: 'BookingCourseParamsObject', pmCourseId?: any | null, pmCourseCategoryId?: any | null, pmCourseOptionIds?: Array<any> | null }> }>, pageInfo: { __typename?: 'KaminariPageInfoObject', currentPage: number, isFirstPage: boolean, isLastPage: boolean, nextPage?: number | null, prevPage?: number | null, totalCount: number, totalPages: number } } };

export type BrandGroupQueryVariables = Exact<{
  urlWord: Scalars['String'];
}>;


export type BrandGroupQuery = { __typename?: 'Query', brandGroup?: { __typename?: 'BrandGroupObject', id: number, name: string, nameKana: string, brands?: Array<{ __typename?: 'BrandObject', id: number, name: string, nameKana?: string | null }> | null } | null };

export type ColumnQueryVariables = Exact<{
  displayId: Scalars['String'];
}>;


export type ColumnQuery = { __typename?: 'Query', column?: { __typename?: 'ColumnObject', displayId: string, title: string, content: string, publishedStartAt: any, eyeCatchingImage?: string | null } | null };

export type ColumnsQueryVariables = Exact<{
  page: Scalars['Int'];
  per?: InputMaybe<Scalars['Int']>;
}>;


export type ColumnsQuery = { __typename?: 'Query', columns: { __typename?: 'ColumnObjectWithKaminariPagination', items: Array<{ __typename?: 'ColumnObject', displayId: string, title: string, content: string, publishedStartAt: any, eyeCatchingImage?: string | null }>, pageInfo: { __typename?: 'KaminariPageInfoObject', currentPage: number, isFirstPage: boolean, isLastPage: boolean, nextPage?: number | null, prevPage?: number | null, totalCount: number, totalPages: number } } };

export type CountOfSearchedShopsQueryVariables = Exact<{
  courseGenreIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  particularConditionIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  shopAreaIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  prefectureId?: InputMaybe<Scalars['Int']>;
  cityIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  railroadLineIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  railroadStationIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  q: Scalars['String'];
}>;


export type CountOfSearchedShopsQuery = { __typename?: 'Query', countOfShops: { __typename?: 'CountOfShopObject', count: number } };

export type CurrentCustomerQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentCustomerQuery = { __typename?: 'Query', currentCustomer?: { __typename?: 'CustomerObject', id: number, pmCustomerId: any, pmShopId: any, name: string, nameKana: string, tel?: string | null, email?: string | null, birthday?: any | null, sex: number, isNeededShopMail: number } | null };

export type CurrentCustomerForChargeHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentCustomerForChargeHistoryQuery = { __typename?: 'Query', currentCustomer?: { __typename?: 'CustomerObject', name: string, customerChargeHistories?: Array<{ __typename?: 'CustomerChargeHistoryObject', expiredDate?: any | null, givenDate?: any | null, charge?: number | null, shopName?: string | null }> | null, customerPointsAndCharges?: { __typename?: 'CustomerPointsAndChargesObject', remainingCharge?: number | null } | null } | null };

export type CurrentCustomerForMyPageQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentCustomerForMyPageQuery = { __typename?: 'Query', currentCustomer?: { __typename?: 'CustomerObject', postCode?: string | null, prefectureId?: number | null, prefectureName?: string | null, address?: string | null, address2?: string | null, birthday?: any | null, email?: string | null, isEnabledToReceiveDm?: number | null, isNeededShopMail: number, name: string, nameKana: string, pmCustomerId: any, pmCustomerCode?: string | null, tel?: string | null, pmCardId?: string | null, customerPointsAndCharges?: { __typename?: 'CustomerPointsAndChargesObject', pointExpiredAtDescription?: string | null, remainingCharge?: number | null, remainingPoints?: number | null } | null, customerCouponInfo?: { __typename?: 'CustomerCouponInfoObject', totalCount?: number | null, coupons?: Array<{ __typename?: 'CustomerCouponObject', name?: string | null, remainingNumber?: number | null }> | null } | null, customerCardInfo?: { __typename?: 'CustomerCardInfoObject', cardBarcodeUrl?: string | null } | null, customerMailMagazineSettings?: { __typename?: 'CustomerMailMagazineSettingsObject', isEnabledToReceiveEmailFromHeadOffice?: number | null, emailSettingsByShop?: Array<{ __typename?: 'CustomerMailMagazineSettingByShopObject', pmShopId?: any | null, shopName?: string | null, isEnabledToReceiveEmailFromShop?: number | null }> | null } | null } | null };

export type CurrentCustomerForPointHistoryQueryVariables = Exact<{ [key: string]: never; }>;


export type CurrentCustomerForPointHistoryQuery = { __typename?: 'Query', currentCustomer?: { __typename?: 'CustomerObject', name: string, customerPointHistories?: Array<{ __typename?: 'CustomerPointHistoryObject', expiredDate?: any | null, givenDate?: any | null, point?: number | null, shopName?: string | null }> | null, customerPointsAndCharges?: { __typename?: 'CustomerPointsAndChargesObject', expiringPoints?: number | null, latestExpiredAt?: any | null, remainingPoints?: number | null } | null } | null };

export type CustomerInformationQueryVariables = Exact<{
  displayId: Scalars['String'];
}>;


export type CustomerInformationQuery = { __typename?: 'Query', customerInformation?: { __typename?: 'CustomerInformationObject', displayId: string, title: string, body: string, tags: Array<string>, eyeCatchingImage?: string | null, publishedStartAt?: any | null } | null };

export type CustomerInformationsQueryVariables = Exact<{
  page: Scalars['Int'];
  per?: InputMaybe<Scalars['Int']>;
}>;


export type CustomerInformationsQuery = { __typename?: 'Query', customerInformations: { __typename?: 'CustomerInformationObjectWithKaminariPagination', items: Array<{ __typename?: 'CustomerInformationObject', displayId: string, title: string, body: string, tags: Array<string>, eyeCatchingImage?: string | null, publishedStartAt?: any | null }>, pageInfo: { __typename?: 'KaminariPageInfoObject', currentPage: number, isFirstPage: boolean, isLastPage: boolean, nextPage?: number | null, prevPage?: number | null, totalCount: number, totalPages: number } } };

export type PrefectureAreasQueryVariables = Exact<{ [key: string]: never; }>;


export type PrefectureAreasQuery = { __typename?: 'Query', prefectureAreas: Array<{ __typename?: 'PrefectureAreaObject', id: number, name: string, prefectures: Array<{ __typename?: 'PrefectureObject', id: number, name: string, sortNo: number }> }> };

export type PrefecturesQueryVariables = Exact<{ [key: string]: never; }>;


export type PrefecturesQuery = { __typename?: 'Query', prefectures: Array<{ __typename?: 'PrefectureObject', id: number, name: string, sortNo: number }> };

export type RailroadStationsQueryVariables = Exact<{
  isHaveShops?: InputMaybe<Scalars['Boolean']>;
  page: Scalars['Int'];
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type RailroadStationsQuery = { __typename?: 'Query', railroadStations: { __typename?: 'RailroadStationObjectWithKaminariPagination', items: Array<{ __typename?: 'RailroadStationObject', id: number, name: string, shopCount: number, prefectureId: number, railroadLine: { __typename?: 'RailroadLineObject', id: number, name: string } }> } };

export type RailroadStationsWithCityQueryVariables = Exact<{
  ids?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
}>;


export type RailroadStationsWithCityQuery = { __typename?: 'Query', cities: { __typename?: 'CityObjectWithKaminariPagination', items: Array<{ __typename?: 'CityObject', railroadStations: { __typename?: 'RailroadStationObjectWithKaminariPagination', items: Array<{ __typename?: 'RailroadStationObject', id: number, name: string, shopCount: number, sortNo: string }> } }> } };

export type RerakuBlogQueryVariables = Exact<{
  displayId: Scalars['String'];
  shopSlug: Scalars['String'];
}>;


export type RerakuBlogQuery = { __typename?: 'Query', rerakuBlog?: { __typename?: 'RerakuBlogObject', displayId: string, publishedStartAt: any, title?: string | null, content: string, eyeCatchingImage?: string | null, shopSlug: string, shopName: string, isShopBookable: boolean, shopTel?: string | null } | null };

export type RerakuBlogsQueryVariables = Exact<{
  shopSlug?: InputMaybe<Scalars['String']>;
  publishedAt?: InputMaybe<Scalars['String']>;
  page?: InputMaybe<Scalars['Int']>;
  per?: InputMaybe<Scalars['Int']>;
}>;


export type RerakuBlogsQuery = { __typename?: 'Query', rerakuBlogs: { __typename?: 'RerakuBlogObjectWithKaminariPagination', items: Array<{ __typename?: 'RerakuBlogObject', displayId: string, publishedStartAt: any, title?: string | null, content: string, eyeCatchingImage?: string | null, shopSlug: string, shopName: string }>, pageInfo: { __typename?: 'KaminariPageInfoObject', totalPages: number, currentPage: number, isFirstPage: boolean, isLastPage: boolean, nextPage?: number | null, prevPage?: number | null, totalCount: number } } };

export type ShopQueryVariables = Exact<{
  id: Scalars['Int'];
}>;


export type ShopQuery = { __typename?: 'Query', shop?: { __typename?: 'ShopObject', id: number, name: string, pmShopId?: any | null, address?: string | null, isBookable: boolean } | null };

export type ShopConditionRelationsQueryVariables = Exact<{ [key: string]: never; }>;


export type ShopConditionRelationsQuery = { __typename?: 'Query', shopConditionRelations: { __typename?: 'ShopConditionRelationsObject', prefectures: Array<{ __typename?: 'PrefectureObject', id: number, name: string, sortNo: number, prefectureArea: { __typename?: 'PrefectureAreaObject', id: number, name: string } }>, prefectureAreas: Array<{ __typename?: 'PrefectureAreaObject', id: number, name: string, prefectures: Array<{ __typename?: 'PrefectureObject', id: number, name: string, sortNo: number }> }>, railroadLines: Array<{ __typename?: 'RailroadLineObject', id: number, name: string }>, courseGenres: Array<{ __typename?: 'CourseGenreObject', id: number, name: string, sortNo: number }>, courseCategories: Array<{ __typename?: 'RerakuCourseCategoryObject', courseCategoryId: number, name: string, sortNo: number }> } };

export type ShopForBookingQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type ShopForBookingQuery = { __typename?: 'Query', shop?: { __typename?: 'ShopObject', id: number, slug: string, name: string, pmShopId?: any | null, address?: string | null, tel?: string | null, isBookable: boolean, isRequiredAdmissionFee: boolean, hasOutsourcedStaff: boolean, openingDate?: any | null, businessOpeningDate?: any | null, isPayAvailable: boolean, pmCourseCategories: Array<{ __typename?: 'PmCourseCategoryObject', name: string, pmCourseCategoryId: any, remarks: string, imageUrl?: string | null, isOption: boolean, courses: Array<{ __typename?: 'CourseObject', pmCourseId: any, courseMinutes: number, imageUrl?: string | null, name: string, price: number, noTaxPrice: number, remarks: string, startAt?: any | null, endAt?: any | null, activeMale: boolean, activeFemale: boolean, courseType?: string | null }>, options: Array<{ __typename?: 'CourseOptionObject', name: string, pmCourseId: any, courseMinutes: number, price: number, noTaxPrice: number, startAt?: any | null, endAt?: any | null, activeMale: boolean, activeFemale: boolean }> }>, staffs: Array<{ __typename?: 'StaffObject', name: string, nickname: string, pmStaffId: any, nominatePrice?: number | null, nominateOptionName?: string | null, canBeNominated: boolean, canBeNominatedBySex: boolean, sex: number, imageUrl?: string | null }>, shopSettings?: { __typename?: 'ShopSettingsObject', closed: boolean, maleDisplay: boolean, maleDisplayName?: string | null, maleNominatePrice?: number | null, maleStickId?: number | null, femaleDisplay: boolean, femaleDisplayName?: string | null, femaleNominatePrice?: number | null, femaleStickId?: number | null } | null } | null };

export type ShopForCourseCategoriesQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type ShopForCourseCategoriesQuery = { __typename?: 'Query', shop?: { __typename?: 'ShopObject', slug: string, tel?: string | null, id: number, name: string, messageFromShopHtml?: string | null, isBookable: boolean, recruitUrl?: string | null, staffs: Array<{ __typename?: 'StaffObject', name: string }>, brand?: { __typename?: 'BrandObject', brandGroup?: { __typename?: 'BrandGroupObject', name: string, id: number } | null } | null, rerakuCourseCategories: Array<{ __typename?: 'RerakuCourseCategoryObject', courseCategoryId: number, name: string, remarks: string, isOption: boolean, imageUrl: string, courses: Array<{ __typename?: 'RerakuCourseObject', courseId?: number | null, name: string, price: number, courseMinutes: number, remarks: string }> }>, rerakuBlogs: { __typename?: 'RerakuBlogObjectWithKaminariPagination', items: Array<{ __typename?: 'RerakuBlogObject', displayId: string }> } } | null };

export type ShopForDetailQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type ShopForDetailQuery = { __typename?: 'Query', shop?: { __typename?: 'ShopObject', slug: string, id: number, name: string, status: ShopStatusEnum, tel?: string | null, note?: string | null, recruitUrl?: string | null, isRequiredAdmissionFee: boolean, admissionFeeText?: string | null, messageFromShopHtml?: string | null, workingTime?: string | null, pmShopId?: any | null, address?: string | null, fullAddress: string, fullStations: Array<string>, businessTimeText?: string | null, access?: string | null, postCode?: string | null, publishedEndAt?: string | null, publishedStartAt?: string | null, lat?: number | null, lng?: number | null, isBookable: boolean, prefectureName?: string | null, nearestShops: { __typename?: 'ShopObjectWithKaminariPagination', items: Array<{ __typename?: 'ShopObject', name: string, slug: string, tel?: string | null, businessTimeText?: string | null, workingTime?: string | null, fullStations: Array<string>, fullAddress: string, companyId?: number | null, lat?: number | null, lng?: number | null, isBookable: boolean, isNew?: boolean | null, distance?: number | null, isRenewal?: boolean | null, isRecentlyOpened?: boolean | null, openingDate?: any | null, renewalOpeningDate?: any | null, images: Array<{ __typename?: 'ShopImageObject', alt?: string | null, sortNo: number, valiantImageUrls: { __typename?: 'ValiantImagesObject', middle: { __typename?: 'ValiantImageObject', url: string, w: number, h: number }, large: { __typename?: 'ValiantImageObject', url: string, w: number, h: number } } }>, bookableDates?: Array<{ __typename?: 'ShopBookableDateObject', date: any, isBookable: boolean }> | null }> }, brand?: { __typename?: 'BrandObject', brandGroup?: { __typename?: 'BrandGroupObject', name: string, id: number } | null } | null, particularConditions: Array<{ __typename?: 'ParticularConditionObject', name: string, id: number }>, paymentMethods: Array<{ __typename?: 'PaymentMethodObject', id: number, name: string, paymentType: PaymentMethodPaymentTypeEnum, imageUrl: string, sortNo: number }>, images: Array<{ __typename?: 'ShopImageObject', alt?: string | null, imageId: number, sortNo: number, type: string, valiantImageUrls: { __typename?: 'ValiantImagesObject', middle: { __typename?: 'ValiantImageObject', url: string, w: number, h: number }, large: { __typename?: 'ValiantImageObject', url: string, w: number, h: number } } }>, rerakuBlogs: { __typename?: 'RerakuBlogObjectWithKaminariPagination', items: Array<{ __typename?: 'RerakuBlogObject', displayId: string, title?: string | null, shopSlug: string, shopName: string }> }, city?: { __typename?: 'CityObject', cityName: string } | null, rerakuCourseCategories: Array<{ __typename?: 'RerakuCourseCategoryObject', name: string }>, staffs: Array<{ __typename?: 'StaffObject', name: string }>, recommendedCourses: Array<{ __typename?: 'RecommendedCourseObject', isBookable: boolean, course: { __typename?: 'CourseObject', pmCourseId: any, pmCourseCategoryId: any, name: string, remarks: string, courseMinutes: number, price: number, noTaxPrice: number, sex: number, activeMale: boolean, activeFemale: boolean, startAt?: any | null, endAt?: any | null, courseType?: string | null, imageUrl?: string | null, isPromotional: boolean, promotionalImageUrl?: string | null } }> } | null };

export type ShopForMessageQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type ShopForMessageQuery = { __typename?: 'Query', shop?: { __typename?: 'ShopObject', id: number, name: string, slug: string, tel?: string | null, isBookable: boolean, recruitUrl?: string | null, messageFromShopHtml?: string | null, brand?: { __typename?: 'BrandObject', brandGroup?: { __typename?: 'BrandGroupObject', name: string, id: number } | null } | null, rerakuBlogs: { __typename?: 'RerakuBlogObjectWithKaminariPagination', items: Array<{ __typename?: 'RerakuBlogObject', displayId: string }> }, rerakuCourseCategories: Array<{ __typename?: 'RerakuCourseCategoryObject', name: string }>, staffs: Array<{ __typename?: 'StaffObject', name: string }> } | null };

export type ShopForRerakuBlogQueryVariables = Exact<{
  slug: Scalars['String'];
  page?: InputMaybe<Scalars['Int']>;
  per?: InputMaybe<Scalars['Int']>;
}>;


export type ShopForRerakuBlogQuery = { __typename?: 'Query', shop?: { __typename?: 'ShopObject', slug: string, id: number, name: string, tel?: string | null, recruitUrl?: string | null, messageFromShopHtml?: string | null, isBookable: boolean, staffs: Array<{ __typename?: 'StaffObject', name: string }>, rerakuBlogs: { __typename?: 'RerakuBlogObjectWithKaminariPagination', items: Array<{ __typename?: 'RerakuBlogObject', displayId: string, publishedStartAt: any, title?: string | null, content: string, eyeCatchingImage?: string | null, shopSlug: string, shopName: string }>, pageInfo: { __typename?: 'KaminariPageInfoObject', totalPages: number, currentPage: number, isFirstPage: boolean, isLastPage: boolean, nextPage?: number | null, prevPage?: number | null, totalCount: number } }, rerakuCourseCategories: Array<{ __typename?: 'RerakuCourseCategoryObject', name: string }> } | null };

export type ShopForStaffQueryVariables = Exact<{
  slug: Scalars['String'];
}>;


export type ShopForStaffQuery = { __typename?: 'Query', shop?: { __typename?: 'ShopObject', id: number, name: string, slug: string, tel?: string | null, isBookable: boolean, recruitUrl?: string | null, messageFromShopHtml?: string | null, brand?: { __typename?: 'BrandObject', brandGroup?: { __typename?: 'BrandGroupObject', name: string, id: number } | null } | null, rerakuBlogs: { __typename?: 'RerakuBlogObjectWithKaminariPagination', items: Array<{ __typename?: 'RerakuBlogObject', displayId: string }> }, rerakuCourseCategories: Array<{ __typename?: 'RerakuCourseCategoryObject', name: string }>, staffs: Array<{ __typename?: 'StaffObject', name: string, nickname: string, pmStaffId: any, nominatePrice?: number | null, nominateOptionName?: string | null, canBeNominated: boolean, canBeNominatedBySex: boolean, sex: number, imageUrl?: string | null, remark?: string | null }> } | null };

export type ShopSearchConditionsQueryVariables = Exact<{
  prefectureId?: InputMaybe<Scalars['Int']>;
  railroadLineIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  skipLoadDataCities?: InputMaybe<Scalars['Boolean']>;
  skipLoadDataRailroadLines?: InputMaybe<Scalars['Boolean']>;
}>;


export type ShopSearchConditionsQuery = { __typename?: 'Query', shopSearchConditions: { __typename?: 'ShopSearchConditionsObject', particularConditions: Array<{ __typename?: 'ParticularConditionObject', id: number, name: string }>, courseGenres: Array<{ __typename?: 'CourseGenreObject', id: number, name: string }>, allPrefectures: Array<{ __typename?: 'PrefectureObject', id: number, name: string, shopCount: number, sortNo: number }>, prefectureAreas: Array<{ __typename?: 'PrefectureAreaObject', id: number, name: string, prefectures: Array<{ __typename?: 'PrefectureObject', id: number, name: string, shopCount: number, sortNo: number }> }>, cities: { __typename?: 'CityObjectWithKaminariPagination', items: Array<{ __typename?: 'CityObject', id: number, cityName: string, shopCount: number, prefecture: { __typename?: 'PrefectureObject', id: number } }> }, railroadLines: Array<{ __typename?: 'RailroadLineObject', id: number, name: string, shopCount: number, sortNo: number, railroadCompanyId: number, railroadStations: { __typename?: 'RailroadStationObjectWithKaminariPagination', items: Array<{ __typename?: 'RailroadStationObject', id: number, name: string, shopCount: number, sortNo: string }> } }> } };

export type ShopSearchTopQueryVariables = Exact<{
  isHaveShops?: InputMaybe<Scalars['Boolean']>;
}>;


export type ShopSearchTopQuery = { __typename?: 'Query', shopSearchConditions: { __typename?: 'ShopSearchConditionsObject', prefectureAreas: Array<{ __typename?: 'PrefectureAreaObject', id: number, name: string, prefectures: Array<{ __typename?: 'PrefectureObject', id: number, name: string, shopCount: number, sortNo: number, cities: { __typename?: 'CityObjectWithKaminariPagination', items: Array<{ __typename?: 'CityObject', id: number, cityName: string }> }, railroadStations: { __typename?: 'RailroadStationObjectWithKaminariPagination', items: Array<{ __typename?: 'RailroadStationObject', id: number, name: string }> } }> }> } };

export type ShopsQueryVariables = Exact<{
  courseGenreIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  courseCategoryIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  particularConditionIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  shopAreaIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  prefectureAreaIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  prefectureId?: InputMaybe<Scalars['Int']>;
  cityIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  railroadLineIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  railroadStationIds?: InputMaybe<Array<Scalars['Int']> | Scalars['Int']>;
  q?: InputMaybe<Scalars['String']>;
  currentLocation?: InputMaybe<CurrentLocationInput>;
  isNew?: InputMaybe<Scalars['Boolean']>;
  isRenewal?: InputMaybe<Scalars['Boolean']>;
  isRecentlyOpened?: InputMaybe<Scalars['Boolean']>;
  page: Scalars['Int'];
}>;


export type ShopsQuery = { __typename?: 'Query', shops: { __typename?: 'ShopObjectWithKaminariPagination', pageInfo: { __typename?: 'KaminariPageInfoObject', totalPages: number, currentPage: number, isFirstPage: boolean, isLastPage: boolean, nextPage?: number | null, prevPage?: number | null, totalCount: number }, items: Array<{ __typename?: 'ShopObject', name: string, slug: string, tel?: string | null, businessTimeText?: string | null, workingTime?: string | null, fullStations: Array<string>, fullAddress: string, companyId?: number | null, lat?: number | null, lng?: number | null, isBookable: boolean, isNew?: boolean | null, distance?: number | null, isRenewal?: boolean | null, isRecentlyOpened?: boolean | null, openingDate?: any | null, closingDate?: any | null, renewalOpeningDate?: any | null, images: Array<{ __typename?: 'ShopImageObject', alt?: string | null, sortNo: number, valiantImageUrls: { __typename?: 'ValiantImagesObject', middle: { __typename?: 'ValiantImageObject', url: string, w: number, h: number }, large: { __typename?: 'ValiantImageObject', url: string, w: number, h: number } } }>, bookableDates?: Array<{ __typename?: 'ShopBookableDateObject', date: any, isBookable: boolean }> | null }> } };

export type TimeTablesByShopQueryVariables = Exact<{
  pmShopId: Scalars['BigInt'];
  courses: Array<BookingCourseInput> | BookingCourseInput;
  staffId?: InputMaybe<Scalars['BigInt']>;
  startDate: Scalars['String'];
  viewDay: Scalars['Int'];
  staffSexId?: InputMaybe<Scalars['Int']>;
}>;


export type TimeTablesByShopQuery = { __typename?: 'Query', timeTables: { __typename?: 'TimeTableObject', timeTableHourRange: { __typename?: 'TimeTableHourRangeObject', startTime: string, endTime: string }, timeTablesByDate: Array<{ __typename?: 'TimeTableByDateObject', date: string, timeTablesByHalfHour: Array<{ __typename?: 'TimeTableByHalfHourObject', halfHour: string, timeTableStatusByHalfHour: { __typename?: 'TimeTableStatusByHalfHourObject', timeTableStatus: TimeTableStatusEnum, timeTableStatusesEvery10Minutes: Array<{ __typename?: 'TimeTableStatusEvery10MinutesObject', startTime: string, status: boolean }> } }> }> } };


export const BookingCancelDocument = `
    mutation BookingCancel($bookingCancelInput: BookingCancelMutationInput!) {
  bookingCancel(input: $bookingCancelInput) {
    result
    bookingCancelled {
      status
    }
  }
}
    `;
export const useBookingCancelMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BookingCancelMutation, TError, BookingCancelMutationVariables, TContext>) =>
    useMutation<BookingCancelMutation, TError, BookingCancelMutationVariables, TContext>(
      ['BookingCancel'],
      (variables?: BookingCancelMutationVariables) => fetcher<BookingCancelMutation, BookingCancelMutationVariables>(BookingCancelDocument, variables)(),
      options
    );
useBookingCancelMutation.fetcher = (variables: BookingCancelMutationVariables, options?: RequestInit['headers']) => fetcher<BookingCancelMutation, BookingCancelMutationVariables>(BookingCancelDocument, variables, options);
export const BookingConfirmDocument = `
    mutation BookingConfirm($bookingConfirmInput: BookingConfirmMutationInput!) {
  bookingConfirm(input: $bookingConfirmInput) {
    result
    bookingConfirmInfo {
      bookingMenu {
        pmCourseCategoryId
        name
        courses {
          pmCourseId
          name
          price
        }
        options {
          pmCourseId
          name
          price
        }
      }
      nominateInfo {
        courseOptionId
        courseOptionName
        price
        noTaxPrice
      }
      isBookable
      totalPrice
      hasCourseIdsChanged
      courseParams {
        pmCourseCategoryId
        pmCourseId
        pmCourseOptionIds
      }
    }
  }
}
    `;
export const useBookingConfirmMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BookingConfirmMutation, TError, BookingConfirmMutationVariables, TContext>) =>
    useMutation<BookingConfirmMutation, TError, BookingConfirmMutationVariables, TContext>(
      ['BookingConfirm'],
      (variables?: BookingConfirmMutationVariables) => fetcher<BookingConfirmMutation, BookingConfirmMutationVariables>(BookingConfirmDocument, variables)(),
      options
    );
useBookingConfirmMutation.fetcher = (variables: BookingConfirmMutationVariables, options?: RequestInit['headers']) => fetcher<BookingConfirmMutation, BookingConfirmMutationVariables>(BookingConfirmDocument, variables, options);
export const BookingGuestInputDocument = `
    mutation BookingGuestInput($bookingGuestInput: BookingGuestInputMutationInput!) {
  bookingGuestInput(input: $bookingGuestInput) {
    result
    booking {
      pmShopId
      pmBookingId
      pmCustomerId
      bookingMenu {
        pmCourseCategoryId
        courses {
          pmCourseId
          name
          price
          noTaxPrice
        }
        options {
          pmCourseId
          name
          price
          noTaxPrice
        }
      }
    }
  }
}
    `;
export const useBookingGuestInputMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BookingGuestInputMutation, TError, BookingGuestInputMutationVariables, TContext>) =>
    useMutation<BookingGuestInputMutation, TError, BookingGuestInputMutationVariables, TContext>(
      ['BookingGuestInput'],
      (variables?: BookingGuestInputMutationVariables) => fetcher<BookingGuestInputMutation, BookingGuestInputMutationVariables>(BookingGuestInputDocument, variables)(),
      options
    );
useBookingGuestInputMutation.fetcher = (variables: BookingGuestInputMutationVariables, options?: RequestInit['headers']) => fetcher<BookingGuestInputMutation, BookingGuestInputMutationVariables>(BookingGuestInputDocument, variables, options);
export const BookingInputDocument = `
    mutation BookingInput($bookingInput: BookingInputMutationInput!) {
  bookingInput(input: $bookingInput) {
    result
    booking {
      pmShopId
      pmBookingId
      pmCustomerId
      bookingMenu {
        pmCourseCategoryId
        courses {
          pmCourseId
          name
          price
          noTaxPrice
        }
        options {
          pmCourseId
          name
          price
          noTaxPrice
        }
      }
    }
  }
}
    `;
export const useBookingInputMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<BookingInputMutation, TError, BookingInputMutationVariables, TContext>) =>
    useMutation<BookingInputMutation, TError, BookingInputMutationVariables, TContext>(
      ['BookingInput'],
      (variables?: BookingInputMutationVariables) => fetcher<BookingInputMutation, BookingInputMutationVariables>(BookingInputDocument, variables)(),
      options
    );
useBookingInputMutation.fetcher = (variables: BookingInputMutationVariables, options?: RequestInit['headers']) => fetcher<BookingInputMutation, BookingInputMutationVariables>(BookingInputDocument, variables, options);
export const CustomerCheckStatusDocument = `
    mutation CustomerCheckStatus($checkPmCustomerStatusMutationInput: CheckPmCustomerStatusMutationInput!) {
  customerCheckPmCustomerStatus(input: $checkPmCustomerStatusMutationInput) {
    pmCustomerStatus
    result
  }
}
    `;
export const useCustomerCheckStatusMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CustomerCheckStatusMutation, TError, CustomerCheckStatusMutationVariables, TContext>) =>
    useMutation<CustomerCheckStatusMutation, TError, CustomerCheckStatusMutationVariables, TContext>(
      ['CustomerCheckStatus'],
      (variables?: CustomerCheckStatusMutationVariables) => fetcher<CustomerCheckStatusMutation, CustomerCheckStatusMutationVariables>(CustomerCheckStatusDocument, variables)(),
      options
    );
useCustomerCheckStatusMutation.fetcher = (variables: CustomerCheckStatusMutationVariables, options?: RequestInit['headers']) => fetcher<CustomerCheckStatusMutation, CustomerCheckStatusMutationVariables>(CustomerCheckStatusDocument, variables, options);
export const CustomerLoginDocument = `
    mutation CustomerLogin($loginByTelOrEmailInput: LoginByTelOrEmailMutationInput!) {
  customerLogin(input: $loginByTelOrEmailInput) {
    result
    customer {
      id
      pmCustomerId
      pmShopId
      name
      nameKana
      tel
      email
      birthday
      sex
      isNeededShopMail
    }
  }
}
    `;
export const useCustomerLoginMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CustomerLoginMutation, TError, CustomerLoginMutationVariables, TContext>) =>
    useMutation<CustomerLoginMutation, TError, CustomerLoginMutationVariables, TContext>(
      ['CustomerLogin'],
      (variables?: CustomerLoginMutationVariables) => fetcher<CustomerLoginMutation, CustomerLoginMutationVariables>(CustomerLoginDocument, variables)(),
      options
    );
useCustomerLoginMutation.fetcher = (variables: CustomerLoginMutationVariables, options?: RequestInit['headers']) => fetcher<CustomerLoginMutation, CustomerLoginMutationVariables>(CustomerLoginDocument, variables, options);
export const CustomerLogoutDocument = `
    mutation CustomerLogout {
  customerLogout(input: {}) {
    result
  }
}
    `;
export const useCustomerLogoutMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CustomerLogoutMutation, TError, CustomerLogoutMutationVariables, TContext>) =>
    useMutation<CustomerLogoutMutation, TError, CustomerLogoutMutationVariables, TContext>(
      ['CustomerLogout'],
      (variables?: CustomerLogoutMutationVariables) => fetcher<CustomerLogoutMutation, CustomerLogoutMutationVariables>(CustomerLogoutDocument, variables)(),
      options
    );
useCustomerLogoutMutation.fetcher = (variables?: CustomerLogoutMutationVariables, options?: RequestInit['headers']) => fetcher<CustomerLogoutMutation, CustomerLogoutMutationVariables>(CustomerLogoutDocument, variables, options);
export const CustomerResetPasswordDocument = `
    mutation CustomerResetPassword($resetPasswordInput: ResetPasswordInputMutationInput!) {
  customerResetPassword(input: $resetPasswordInput) {
    result
  }
}
    `;
export const useCustomerResetPasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CustomerResetPasswordMutation, TError, CustomerResetPasswordMutationVariables, TContext>) =>
    useMutation<CustomerResetPasswordMutation, TError, CustomerResetPasswordMutationVariables, TContext>(
      ['CustomerResetPassword'],
      (variables?: CustomerResetPasswordMutationVariables) => fetcher<CustomerResetPasswordMutation, CustomerResetPasswordMutationVariables>(CustomerResetPasswordDocument, variables)(),
      options
    );
useCustomerResetPasswordMutation.fetcher = (variables: CustomerResetPasswordMutationVariables, options?: RequestInit['headers']) => fetcher<CustomerResetPasswordMutation, CustomerResetPasswordMutationVariables>(CustomerResetPasswordDocument, variables, options);
export const CustomerSignUpDocument = `
    mutation CustomerSignUp($signUpMutationInput: SignUpMutationInput!) {
  customerSignUp(input: $signUpMutationInput) {
    result
    customer {
      id
      pmCustomerId
      pmShopId
      name
      nameKana
      tel
      email
      birthday
      sex
      isNeededShopMail
    }
  }
}
    `;
export const useCustomerSignUpMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CustomerSignUpMutation, TError, CustomerSignUpMutationVariables, TContext>) =>
    useMutation<CustomerSignUpMutation, TError, CustomerSignUpMutationVariables, TContext>(
      ['CustomerSignUp'],
      (variables?: CustomerSignUpMutationVariables) => fetcher<CustomerSignUpMutation, CustomerSignUpMutationVariables>(CustomerSignUpDocument, variables)(),
      options
    );
useCustomerSignUpMutation.fetcher = (variables: CustomerSignUpMutationVariables, options?: RequestInit['headers']) => fetcher<CustomerSignUpMutation, CustomerSignUpMutationVariables>(CustomerSignUpDocument, variables, options);
export const CustomerUpdateEmailDocument = `
    mutation CustomerUpdateEmail($updateEmailMutationInput: UpdateCustomerEmailMutationInput!) {
  customerUpdateEmail(input: $updateEmailMutationInput) {
    result
  }
}
    `;
export const useCustomerUpdateEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CustomerUpdateEmailMutation, TError, CustomerUpdateEmailMutationVariables, TContext>) =>
    useMutation<CustomerUpdateEmailMutation, TError, CustomerUpdateEmailMutationVariables, TContext>(
      ['CustomerUpdateEmail'],
      (variables?: CustomerUpdateEmailMutationVariables) => fetcher<CustomerUpdateEmailMutation, CustomerUpdateEmailMutationVariables>(CustomerUpdateEmailDocument, variables)(),
      options
    );
useCustomerUpdateEmailMutation.fetcher = (variables: CustomerUpdateEmailMutationVariables, options?: RequestInit['headers']) => fetcher<CustomerUpdateEmailMutation, CustomerUpdateEmailMutationVariables>(CustomerUpdateEmailDocument, variables, options);
export const CustomerUpdateMailMagazineSettingsDocument = `
    mutation CustomerUpdateMailMagazineSettings($updateCustomerMailMagazineSettingsMutationInput: UpdateCustomerMailMagazineSettingsMutationInput!) {
  customerUpdateMailMagazineSettings(
    input: $updateCustomerMailMagazineSettingsMutationInput
  ) {
    result
  }
}
    `;
export const useCustomerUpdateMailMagazineSettingsMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CustomerUpdateMailMagazineSettingsMutation, TError, CustomerUpdateMailMagazineSettingsMutationVariables, TContext>) =>
    useMutation<CustomerUpdateMailMagazineSettingsMutation, TError, CustomerUpdateMailMagazineSettingsMutationVariables, TContext>(
      ['CustomerUpdateMailMagazineSettings'],
      (variables?: CustomerUpdateMailMagazineSettingsMutationVariables) => fetcher<CustomerUpdateMailMagazineSettingsMutation, CustomerUpdateMailMagazineSettingsMutationVariables>(CustomerUpdateMailMagazineSettingsDocument, variables)(),
      options
    );
useCustomerUpdateMailMagazineSettingsMutation.fetcher = (variables: CustomerUpdateMailMagazineSettingsMutationVariables, options?: RequestInit['headers']) => fetcher<CustomerUpdateMailMagazineSettingsMutation, CustomerUpdateMailMagazineSettingsMutationVariables>(CustomerUpdateMailMagazineSettingsDocument, variables, options);
export const CustomerUpdatePasswordDocument = `
    mutation CustomerUpdatePassword($updateCustomerPasswordInput: UpdateCustomerPasswordMutationInput!) {
  customerUpdatePassword(input: $updateCustomerPasswordInput) {
    result
  }
}
    `;
export const useCustomerUpdatePasswordMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CustomerUpdatePasswordMutation, TError, CustomerUpdatePasswordMutationVariables, TContext>) =>
    useMutation<CustomerUpdatePasswordMutation, TError, CustomerUpdatePasswordMutationVariables, TContext>(
      ['CustomerUpdatePassword'],
      (variables?: CustomerUpdatePasswordMutationVariables) => fetcher<CustomerUpdatePasswordMutation, CustomerUpdatePasswordMutationVariables>(CustomerUpdatePasswordDocument, variables)(),
      options
    );
useCustomerUpdatePasswordMutation.fetcher = (variables: CustomerUpdatePasswordMutationVariables, options?: RequestInit['headers']) => fetcher<CustomerUpdatePasswordMutation, CustomerUpdatePasswordMutationVariables>(CustomerUpdatePasswordDocument, variables, options);
export const CustomerUpdateProfileDocument = `
    mutation CustomerUpdateProfile($updateProfileMutationInput: UpdateCustomerProfileMutationInput!) {
  customerUpdateProfile(input: $updateProfileMutationInput) {
    result
  }
}
    `;
export const useCustomerUpdateProfileMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CustomerUpdateProfileMutation, TError, CustomerUpdateProfileMutationVariables, TContext>) =>
    useMutation<CustomerUpdateProfileMutation, TError, CustomerUpdateProfileMutationVariables, TContext>(
      ['CustomerUpdateProfile'],
      (variables?: CustomerUpdateProfileMutationVariables) => fetcher<CustomerUpdateProfileMutation, CustomerUpdateProfileMutationVariables>(CustomerUpdateProfileDocument, variables)(),
      options
    );
useCustomerUpdateProfileMutation.fetcher = (variables: CustomerUpdateProfileMutationVariables, options?: RequestInit['headers']) => fetcher<CustomerUpdateProfileMutation, CustomerUpdateProfileMutationVariables>(CustomerUpdateProfileDocument, variables, options);
export const CustomerUpdateTelDocument = `
    mutation CustomerUpdateTel($updateTelMutationInput: UpdateCustomerTelMutationInput!) {
  customerUpdateTel(input: $updateTelMutationInput) {
    result
  }
}
    `;
export const useCustomerUpdateTelMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CustomerUpdateTelMutation, TError, CustomerUpdateTelMutationVariables, TContext>) =>
    useMutation<CustomerUpdateTelMutation, TError, CustomerUpdateTelMutationVariables, TContext>(
      ['CustomerUpdateTel'],
      (variables?: CustomerUpdateTelMutationVariables) => fetcher<CustomerUpdateTelMutation, CustomerUpdateTelMutationVariables>(CustomerUpdateTelDocument, variables)(),
      options
    );
useCustomerUpdateTelMutation.fetcher = (variables: CustomerUpdateTelMutationVariables, options?: RequestInit['headers']) => fetcher<CustomerUpdateTelMutation, CustomerUpdateTelMutationVariables>(CustomerUpdateTelDocument, variables, options);
export const CustomerValidateAuthenticationCodeDocument = `
    mutation CustomerValidateAuthenticationCode($validateAuthenticationCodeMutationInput: ValidateAuthenticationCodeMutationInput!) {
  customerValidateAuthenticationCode(
    input: $validateAuthenticationCodeMutationInput
  ) {
    result
    pmCustomerStatus
    pmCustomerEmail
    pmCustomerTel
    authenticationToken
  }
}
    `;
export const useCustomerValidateAuthenticationCodeMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CustomerValidateAuthenticationCodeMutation, TError, CustomerValidateAuthenticationCodeMutationVariables, TContext>) =>
    useMutation<CustomerValidateAuthenticationCodeMutation, TError, CustomerValidateAuthenticationCodeMutationVariables, TContext>(
      ['CustomerValidateAuthenticationCode'],
      (variables?: CustomerValidateAuthenticationCodeMutationVariables) => fetcher<CustomerValidateAuthenticationCodeMutation, CustomerValidateAuthenticationCodeMutationVariables>(CustomerValidateAuthenticationCodeDocument, variables)(),
      options
    );
useCustomerValidateAuthenticationCodeMutation.fetcher = (variables: CustomerValidateAuthenticationCodeMutationVariables, options?: RequestInit['headers']) => fetcher<CustomerValidateAuthenticationCodeMutation, CustomerValidateAuthenticationCodeMutationVariables>(CustomerValidateAuthenticationCodeDocument, variables, options);
export const CustomerVerifyTelDocument = `
    mutation CustomerVerifyTel($verifyTelMutationInput: VerifyTelMutationInput!) {
  customerVerifyTel(input: $verifyTelMutationInput) {
    result
    authenticationToken
    pmCustomerStatus
  }
}
    `;
export const useCustomerVerifyTelMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CustomerVerifyTelMutation, TError, CustomerVerifyTelMutationVariables, TContext>) =>
    useMutation<CustomerVerifyTelMutation, TError, CustomerVerifyTelMutationVariables, TContext>(
      ['CustomerVerifyTel'],
      (variables?: CustomerVerifyTelMutationVariables) => fetcher<CustomerVerifyTelMutation, CustomerVerifyTelMutationVariables>(CustomerVerifyTelDocument, variables)(),
      options
    );
useCustomerVerifyTelMutation.fetcher = (variables: CustomerVerifyTelMutationVariables, options?: RequestInit['headers']) => fetcher<CustomerVerifyTelMutation, CustomerVerifyTelMutationVariables>(CustomerVerifyTelDocument, variables, options);
export const CustomerVerifyTelOrEmailDocument = `
    mutation CustomerVerifyTelOrEmail($verifyTelOrEmailMutationInput: VerifyTelOrEmailMutationInput!) {
  customerVerifyTelOrEmail(input: $verifyTelOrEmailMutationInput) {
    result
    authenticationToken
  }
}
    `;
export const useCustomerVerifyTelOrEmailMutation = <
      TError = unknown,
      TContext = unknown
    >(options?: UseMutationOptions<CustomerVerifyTelOrEmailMutation, TError, CustomerVerifyTelOrEmailMutationVariables, TContext>) =>
    useMutation<CustomerVerifyTelOrEmailMutation, TError, CustomerVerifyTelOrEmailMutationVariables, TContext>(
      ['CustomerVerifyTelOrEmail'],
      (variables?: CustomerVerifyTelOrEmailMutationVariables) => fetcher<CustomerVerifyTelOrEmailMutation, CustomerVerifyTelOrEmailMutationVariables>(CustomerVerifyTelOrEmailDocument, variables)(),
      options
    );
useCustomerVerifyTelOrEmailMutation.fetcher = (variables: CustomerVerifyTelOrEmailMutationVariables, options?: RequestInit['headers']) => fetcher<CustomerVerifyTelOrEmailMutation, CustomerVerifyTelOrEmailMutationVariables>(CustomerVerifyTelOrEmailDocument, variables, options);
export const BannersDocument = `
    query banners {
  banners {
    id
    altText
    spImage
    pcImage
    imageLink
    publishedStartAt
  }
}
    `;
export const useBannersQuery = <
      TData = BannersQuery,
      TError = unknown
    >(
      variables?: BannersQueryVariables,
      options?: UseQueryOptions<BannersQuery, TError, TData>
    ) =>
    useQuery<BannersQuery, TError, TData>(
      variables === undefined ? ['banners'] : ['banners', variables],
      fetcher<BannersQuery, BannersQueryVariables>(BannersDocument, variables),
      options
    );

useBannersQuery.getKey = (variables?: BannersQueryVariables) => variables === undefined ? ['banners'] : ['banners', variables];
;

useBannersQuery.fetcher = (variables?: BannersQueryVariables, options?: RequestInit['headers']) => fetcher<BannersQuery, BannersQueryVariables>(BannersDocument, variables, options);
export const BookingCancelTypeDocument = `
    query bookingCancelType {
  bookingCancelType {
    text
    value
  }
}
    `;
export const useBookingCancelTypeQuery = <
      TData = BookingCancelTypeQuery,
      TError = unknown
    >(
      variables?: BookingCancelTypeQueryVariables,
      options?: UseQueryOptions<BookingCancelTypeQuery, TError, TData>
    ) =>
    useQuery<BookingCancelTypeQuery, TError, TData>(
      variables === undefined ? ['bookingCancelType'] : ['bookingCancelType', variables],
      fetcher<BookingCancelTypeQuery, BookingCancelTypeQueryVariables>(BookingCancelTypeDocument, variables),
      options
    );

useBookingCancelTypeQuery.getKey = (variables?: BookingCancelTypeQueryVariables) => variables === undefined ? ['bookingCancelType'] : ['bookingCancelType', variables];
;

useBookingCancelTypeQuery.fetcher = (variables?: BookingCancelTypeQueryVariables, options?: RequestInit['headers']) => fetcher<BookingCancelTypeQuery, BookingCancelTypeQueryVariables>(BookingCancelTypeDocument, variables, options);
export const BookingHistoriesDocument = `
    query BookingHistories($page: Int!) {
  bookingHistories(page: $page) {
    items {
      startTime
      shopName
      shopSlug
      shopTel
      staffName
      courseName
      price
      cancelledDate
      isCancellable
      isShopClosed
      isAlreadyTreated
      isDesignated
      isCourseBookable
      bookingHistoryCourses {
        pmCourseId
        pmCourseCategoryId
        pmCourseOptionIds
      }
      designedStaffId
      pmShopId
      pmBookingId
      options
    }
    pageInfo {
      currentPage
      isFirstPage
      isLastPage
      nextPage
      prevPage
      totalCount
      totalPages
    }
  }
}
    `;
export const useBookingHistoriesQuery = <
      TData = BookingHistoriesQuery,
      TError = unknown
    >(
      variables: BookingHistoriesQueryVariables,
      options?: UseQueryOptions<BookingHistoriesQuery, TError, TData>
    ) =>
    useQuery<BookingHistoriesQuery, TError, TData>(
      ['BookingHistories', variables],
      fetcher<BookingHistoriesQuery, BookingHistoriesQueryVariables>(BookingHistoriesDocument, variables),
      options
    );

useBookingHistoriesQuery.getKey = (variables: BookingHistoriesQueryVariables) => ['BookingHistories', variables];
;

useBookingHistoriesQuery.fetcher = (variables: BookingHistoriesQueryVariables, options?: RequestInit['headers']) => fetcher<BookingHistoriesQuery, BookingHistoriesQueryVariables>(BookingHistoriesDocument, variables, options);
export const BrandGroupDocument = `
    query BrandGroup($urlWord: String!) {
  brandGroup(urlWord: $urlWord) {
    id
    name
    nameKana
    brands {
      id
      name
      nameKana
    }
  }
}
    `;
export const useBrandGroupQuery = <
      TData = BrandGroupQuery,
      TError = unknown
    >(
      variables: BrandGroupQueryVariables,
      options?: UseQueryOptions<BrandGroupQuery, TError, TData>
    ) =>
    useQuery<BrandGroupQuery, TError, TData>(
      ['BrandGroup', variables],
      fetcher<BrandGroupQuery, BrandGroupQueryVariables>(BrandGroupDocument, variables),
      options
    );

useBrandGroupQuery.getKey = (variables: BrandGroupQueryVariables) => ['BrandGroup', variables];
;

useBrandGroupQuery.fetcher = (variables: BrandGroupQueryVariables, options?: RequestInit['headers']) => fetcher<BrandGroupQuery, BrandGroupQueryVariables>(BrandGroupDocument, variables, options);
export const ColumnDocument = `
    query column($displayId: String!) {
  column(displayId: $displayId) {
    displayId
    title
    content
    publishedStartAt
    eyeCatchingImage
  }
}
    `;
export const useColumnQuery = <
      TData = ColumnQuery,
      TError = unknown
    >(
      variables: ColumnQueryVariables,
      options?: UseQueryOptions<ColumnQuery, TError, TData>
    ) =>
    useQuery<ColumnQuery, TError, TData>(
      ['column', variables],
      fetcher<ColumnQuery, ColumnQueryVariables>(ColumnDocument, variables),
      options
    );

useColumnQuery.getKey = (variables: ColumnQueryVariables) => ['column', variables];
;

useColumnQuery.fetcher = (variables: ColumnQueryVariables, options?: RequestInit['headers']) => fetcher<ColumnQuery, ColumnQueryVariables>(ColumnDocument, variables, options);
export const ColumnsDocument = `
    query columns($page: Int!, $per: Int) {
  columns(page: $page, per: $per) {
    items {
      displayId
      title
      content
      publishedStartAt
      eyeCatchingImage
    }
    pageInfo {
      currentPage
      isFirstPage
      isLastPage
      nextPage
      prevPage
      totalCount
      totalPages
    }
  }
}
    `;
export const useColumnsQuery = <
      TData = ColumnsQuery,
      TError = unknown
    >(
      variables: ColumnsQueryVariables,
      options?: UseQueryOptions<ColumnsQuery, TError, TData>
    ) =>
    useQuery<ColumnsQuery, TError, TData>(
      ['columns', variables],
      fetcher<ColumnsQuery, ColumnsQueryVariables>(ColumnsDocument, variables),
      options
    );

useColumnsQuery.getKey = (variables: ColumnsQueryVariables) => ['columns', variables];
;

useColumnsQuery.fetcher = (variables: ColumnsQueryVariables, options?: RequestInit['headers']) => fetcher<ColumnsQuery, ColumnsQueryVariables>(ColumnsDocument, variables, options);
export const CountOfSearchedShopsDocument = `
    query CountOfSearchedShops($courseGenreIds: [Int!], $particularConditionIds: [Int!], $shopAreaIds: [Int!], $prefectureId: Int, $cityIds: [Int!], $railroadLineIds: [Int!], $railroadStationIds: [Int!], $q: String!) {
  countOfShops(
    courseGenreIds: $courseGenreIds
    particularConditionIds: $particularConditionIds
    shopAreaIds: $shopAreaIds
    prefectureId: $prefectureId
    cityIds: $cityIds
    railroadLineIds: $railroadLineIds
    railroadStationIds: $railroadStationIds
    q: $q
  ) {
    count
  }
}
    `;
export const useCountOfSearchedShopsQuery = <
      TData = CountOfSearchedShopsQuery,
      TError = unknown
    >(
      variables: CountOfSearchedShopsQueryVariables,
      options?: UseQueryOptions<CountOfSearchedShopsQuery, TError, TData>
    ) =>
    useQuery<CountOfSearchedShopsQuery, TError, TData>(
      ['CountOfSearchedShops', variables],
      fetcher<CountOfSearchedShopsQuery, CountOfSearchedShopsQueryVariables>(CountOfSearchedShopsDocument, variables),
      options
    );

useCountOfSearchedShopsQuery.getKey = (variables: CountOfSearchedShopsQueryVariables) => ['CountOfSearchedShops', variables];
;

useCountOfSearchedShopsQuery.fetcher = (variables: CountOfSearchedShopsQueryVariables, options?: RequestInit['headers']) => fetcher<CountOfSearchedShopsQuery, CountOfSearchedShopsQueryVariables>(CountOfSearchedShopsDocument, variables, options);
export const CurrentCustomerDocument = `
    query CurrentCustomer {
  currentCustomer {
    id
    pmCustomerId
    pmShopId
    name
    nameKana
    tel
    email
    birthday
    sex
    isNeededShopMail
  }
}
    `;
export const useCurrentCustomerQuery = <
      TData = CurrentCustomerQuery,
      TError = unknown
    >(
      variables?: CurrentCustomerQueryVariables,
      options?: UseQueryOptions<CurrentCustomerQuery, TError, TData>
    ) =>
    useQuery<CurrentCustomerQuery, TError, TData>(
      variables === undefined ? ['CurrentCustomer'] : ['CurrentCustomer', variables],
      fetcher<CurrentCustomerQuery, CurrentCustomerQueryVariables>(CurrentCustomerDocument, variables),
      options
    );

useCurrentCustomerQuery.getKey = (variables?: CurrentCustomerQueryVariables) => variables === undefined ? ['CurrentCustomer'] : ['CurrentCustomer', variables];
;

useCurrentCustomerQuery.fetcher = (variables?: CurrentCustomerQueryVariables, options?: RequestInit['headers']) => fetcher<CurrentCustomerQuery, CurrentCustomerQueryVariables>(CurrentCustomerDocument, variables, options);
export const CurrentCustomerForChargeHistoryDocument = `
    query CurrentCustomerForChargeHistory {
  currentCustomer {
    name
    customerChargeHistories {
      expiredDate
      givenDate
      charge
      shopName
    }
    customerPointsAndCharges {
      remainingCharge
    }
  }
}
    `;
export const useCurrentCustomerForChargeHistoryQuery = <
      TData = CurrentCustomerForChargeHistoryQuery,
      TError = unknown
    >(
      variables?: CurrentCustomerForChargeHistoryQueryVariables,
      options?: UseQueryOptions<CurrentCustomerForChargeHistoryQuery, TError, TData>
    ) =>
    useQuery<CurrentCustomerForChargeHistoryQuery, TError, TData>(
      variables === undefined ? ['CurrentCustomerForChargeHistory'] : ['CurrentCustomerForChargeHistory', variables],
      fetcher<CurrentCustomerForChargeHistoryQuery, CurrentCustomerForChargeHistoryQueryVariables>(CurrentCustomerForChargeHistoryDocument, variables),
      options
    );

useCurrentCustomerForChargeHistoryQuery.getKey = (variables?: CurrentCustomerForChargeHistoryQueryVariables) => variables === undefined ? ['CurrentCustomerForChargeHistory'] : ['CurrentCustomerForChargeHistory', variables];
;

useCurrentCustomerForChargeHistoryQuery.fetcher = (variables?: CurrentCustomerForChargeHistoryQueryVariables, options?: RequestInit['headers']) => fetcher<CurrentCustomerForChargeHistoryQuery, CurrentCustomerForChargeHistoryQueryVariables>(CurrentCustomerForChargeHistoryDocument, variables, options);
export const CurrentCustomerForMyPageDocument = `
    query CurrentCustomerForMyPage {
  currentCustomer {
    postCode
    prefectureId
    prefectureName
    address
    address2
    birthday
    customerPointsAndCharges {
      pointExpiredAtDescription
      remainingCharge
      remainingPoints
    }
    customerCouponInfo {
      coupons {
        name
        remainingNumber
      }
      totalCount
    }
    customerCardInfo {
      cardBarcodeUrl
    }
    customerMailMagazineSettings {
      isEnabledToReceiveEmailFromHeadOffice
      emailSettingsByShop {
        pmShopId
        shopName
        isEnabledToReceiveEmailFromShop
      }
    }
    email
    isEnabledToReceiveDm
    isNeededShopMail
    name
    nameKana
    pmCustomerId
    pmCustomerCode
    tel
    pmCardId
  }
}
    `;
export const useCurrentCustomerForMyPageQuery = <
      TData = CurrentCustomerForMyPageQuery,
      TError = unknown
    >(
      variables?: CurrentCustomerForMyPageQueryVariables,
      options?: UseQueryOptions<CurrentCustomerForMyPageQuery, TError, TData>
    ) =>
    useQuery<CurrentCustomerForMyPageQuery, TError, TData>(
      variables === undefined ? ['CurrentCustomerForMyPage'] : ['CurrentCustomerForMyPage', variables],
      fetcher<CurrentCustomerForMyPageQuery, CurrentCustomerForMyPageQueryVariables>(CurrentCustomerForMyPageDocument, variables),
      options
    );

useCurrentCustomerForMyPageQuery.getKey = (variables?: CurrentCustomerForMyPageQueryVariables) => variables === undefined ? ['CurrentCustomerForMyPage'] : ['CurrentCustomerForMyPage', variables];
;

useCurrentCustomerForMyPageQuery.fetcher = (variables?: CurrentCustomerForMyPageQueryVariables, options?: RequestInit['headers']) => fetcher<CurrentCustomerForMyPageQuery, CurrentCustomerForMyPageQueryVariables>(CurrentCustomerForMyPageDocument, variables, options);
export const CurrentCustomerForPointHistoryDocument = `
    query CurrentCustomerForPointHistory {
  currentCustomer {
    name
    customerPointHistories {
      expiredDate
      givenDate
      point
      shopName
    }
    customerPointsAndCharges {
      expiringPoints
      latestExpiredAt
      remainingPoints
    }
  }
}
    `;
export const useCurrentCustomerForPointHistoryQuery = <
      TData = CurrentCustomerForPointHistoryQuery,
      TError = unknown
    >(
      variables?: CurrentCustomerForPointHistoryQueryVariables,
      options?: UseQueryOptions<CurrentCustomerForPointHistoryQuery, TError, TData>
    ) =>
    useQuery<CurrentCustomerForPointHistoryQuery, TError, TData>(
      variables === undefined ? ['CurrentCustomerForPointHistory'] : ['CurrentCustomerForPointHistory', variables],
      fetcher<CurrentCustomerForPointHistoryQuery, CurrentCustomerForPointHistoryQueryVariables>(CurrentCustomerForPointHistoryDocument, variables),
      options
    );

useCurrentCustomerForPointHistoryQuery.getKey = (variables?: CurrentCustomerForPointHistoryQueryVariables) => variables === undefined ? ['CurrentCustomerForPointHistory'] : ['CurrentCustomerForPointHistory', variables];
;

useCurrentCustomerForPointHistoryQuery.fetcher = (variables?: CurrentCustomerForPointHistoryQueryVariables, options?: RequestInit['headers']) => fetcher<CurrentCustomerForPointHistoryQuery, CurrentCustomerForPointHistoryQueryVariables>(CurrentCustomerForPointHistoryDocument, variables, options);
export const CustomerInformationDocument = `
    query customerInformation($displayId: String!) {
  customerInformation(displayId: $displayId) {
    displayId
    title
    body
    tags
    eyeCatchingImage
    publishedStartAt
  }
}
    `;
export const useCustomerInformationQuery = <
      TData = CustomerInformationQuery,
      TError = unknown
    >(
      variables: CustomerInformationQueryVariables,
      options?: UseQueryOptions<CustomerInformationQuery, TError, TData>
    ) =>
    useQuery<CustomerInformationQuery, TError, TData>(
      ['customerInformation', variables],
      fetcher<CustomerInformationQuery, CustomerInformationQueryVariables>(CustomerInformationDocument, variables),
      options
    );

useCustomerInformationQuery.getKey = (variables: CustomerInformationQueryVariables) => ['customerInformation', variables];
;

useCustomerInformationQuery.fetcher = (variables: CustomerInformationQueryVariables, options?: RequestInit['headers']) => fetcher<CustomerInformationQuery, CustomerInformationQueryVariables>(CustomerInformationDocument, variables, options);
export const CustomerInformationsDocument = `
    query customerInformations($page: Int!, $per: Int) {
  customerInformations(page: $page, per: $per) {
    items {
      displayId
      title
      body
      tags
      eyeCatchingImage
      publishedStartAt
    }
    pageInfo {
      currentPage
      isFirstPage
      isLastPage
      nextPage
      prevPage
      totalCount
      totalPages
    }
  }
}
    `;
export const useCustomerInformationsQuery = <
      TData = CustomerInformationsQuery,
      TError = unknown
    >(
      variables: CustomerInformationsQueryVariables,
      options?: UseQueryOptions<CustomerInformationsQuery, TError, TData>
    ) =>
    useQuery<CustomerInformationsQuery, TError, TData>(
      ['customerInformations', variables],
      fetcher<CustomerInformationsQuery, CustomerInformationsQueryVariables>(CustomerInformationsDocument, variables),
      options
    );

useCustomerInformationsQuery.getKey = (variables: CustomerInformationsQueryVariables) => ['customerInformations', variables];
;

useCustomerInformationsQuery.fetcher = (variables: CustomerInformationsQueryVariables, options?: RequestInit['headers']) => fetcher<CustomerInformationsQuery, CustomerInformationsQueryVariables>(CustomerInformationsDocument, variables, options);
export const PrefectureAreasDocument = `
    query PrefectureAreas {
  prefectureAreas {
    id
    name
    prefectures {
      id
      name
      sortNo
    }
  }
}
    `;
export const usePrefectureAreasQuery = <
      TData = PrefectureAreasQuery,
      TError = unknown
    >(
      variables?: PrefectureAreasQueryVariables,
      options?: UseQueryOptions<PrefectureAreasQuery, TError, TData>
    ) =>
    useQuery<PrefectureAreasQuery, TError, TData>(
      variables === undefined ? ['PrefectureAreas'] : ['PrefectureAreas', variables],
      fetcher<PrefectureAreasQuery, PrefectureAreasQueryVariables>(PrefectureAreasDocument, variables),
      options
    );

usePrefectureAreasQuery.getKey = (variables?: PrefectureAreasQueryVariables) => variables === undefined ? ['PrefectureAreas'] : ['PrefectureAreas', variables];
;

usePrefectureAreasQuery.fetcher = (variables?: PrefectureAreasQueryVariables, options?: RequestInit['headers']) => fetcher<PrefectureAreasQuery, PrefectureAreasQueryVariables>(PrefectureAreasDocument, variables, options);
export const PrefecturesDocument = `
    query Prefectures {
  prefectures(isHaveShops: true) {
    id
    name
    sortNo
  }
}
    `;
export const usePrefecturesQuery = <
      TData = PrefecturesQuery,
      TError = unknown
    >(
      variables?: PrefecturesQueryVariables,
      options?: UseQueryOptions<PrefecturesQuery, TError, TData>
    ) =>
    useQuery<PrefecturesQuery, TError, TData>(
      variables === undefined ? ['Prefectures'] : ['Prefectures', variables],
      fetcher<PrefecturesQuery, PrefecturesQueryVariables>(PrefecturesDocument, variables),
      options
    );

usePrefecturesQuery.getKey = (variables?: PrefecturesQueryVariables) => variables === undefined ? ['Prefectures'] : ['Prefectures', variables];
;

usePrefecturesQuery.fetcher = (variables?: PrefecturesQueryVariables, options?: RequestInit['headers']) => fetcher<PrefecturesQuery, PrefecturesQueryVariables>(PrefecturesDocument, variables, options);
export const RailroadStationsDocument = `
    query railroadStations($isHaveShops: Boolean, $page: Int!, $ids: [Int!]) {
  railroadStations(isHaveShops: $isHaveShops, page: $page, ids: $ids) {
    items {
      id
      name
      shopCount
      prefectureId
      railroadLine {
        id
        name
      }
    }
  }
}
    `;
export const useRailroadStationsQuery = <
      TData = RailroadStationsQuery,
      TError = unknown
    >(
      variables: RailroadStationsQueryVariables,
      options?: UseQueryOptions<RailroadStationsQuery, TError, TData>
    ) =>
    useQuery<RailroadStationsQuery, TError, TData>(
      ['railroadStations', variables],
      fetcher<RailroadStationsQuery, RailroadStationsQueryVariables>(RailroadStationsDocument, variables),
      options
    );

useRailroadStationsQuery.getKey = (variables: RailroadStationsQueryVariables) => ['railroadStations', variables];
;

useRailroadStationsQuery.fetcher = (variables: RailroadStationsQueryVariables, options?: RequestInit['headers']) => fetcher<RailroadStationsQuery, RailroadStationsQueryVariables>(RailroadStationsDocument, variables, options);
export const RailroadStationsWithCityDocument = `
    query railroadStationsWithCity($ids: [Int!]) {
  cities(ids: $ids, isHaveShops: true) {
    items {
      railroadStations(isHaveShops: true) {
        items {
          id
          name
          shopCount
          sortNo
        }
      }
    }
  }
}
    `;
export const useRailroadStationsWithCityQuery = <
      TData = RailroadStationsWithCityQuery,
      TError = unknown
    >(
      variables?: RailroadStationsWithCityQueryVariables,
      options?: UseQueryOptions<RailroadStationsWithCityQuery, TError, TData>
    ) =>
    useQuery<RailroadStationsWithCityQuery, TError, TData>(
      variables === undefined ? ['railroadStationsWithCity'] : ['railroadStationsWithCity', variables],
      fetcher<RailroadStationsWithCityQuery, RailroadStationsWithCityQueryVariables>(RailroadStationsWithCityDocument, variables),
      options
    );

useRailroadStationsWithCityQuery.getKey = (variables?: RailroadStationsWithCityQueryVariables) => variables === undefined ? ['railroadStationsWithCity'] : ['railroadStationsWithCity', variables];
;

useRailroadStationsWithCityQuery.fetcher = (variables?: RailroadStationsWithCityQueryVariables, options?: RequestInit['headers']) => fetcher<RailroadStationsWithCityQuery, RailroadStationsWithCityQueryVariables>(RailroadStationsWithCityDocument, variables, options);
export const RerakuBlogDocument = `
    query rerakuBlog($displayId: String!, $shopSlug: String!) {
  rerakuBlog(displayId: $displayId, shopSlug: $shopSlug) {
    displayId
    publishedStartAt
    title
    content
    eyeCatchingImage
    shopSlug
    shopName
    isShopBookable
    shopTel
  }
}
    `;
export const useRerakuBlogQuery = <
      TData = RerakuBlogQuery,
      TError = unknown
    >(
      variables: RerakuBlogQueryVariables,
      options?: UseQueryOptions<RerakuBlogQuery, TError, TData>
    ) =>
    useQuery<RerakuBlogQuery, TError, TData>(
      ['rerakuBlog', variables],
      fetcher<RerakuBlogQuery, RerakuBlogQueryVariables>(RerakuBlogDocument, variables),
      options
    );

useRerakuBlogQuery.getKey = (variables: RerakuBlogQueryVariables) => ['rerakuBlog', variables];
;

useRerakuBlogQuery.fetcher = (variables: RerakuBlogQueryVariables, options?: RequestInit['headers']) => fetcher<RerakuBlogQuery, RerakuBlogQueryVariables>(RerakuBlogDocument, variables, options);
export const RerakuBlogsDocument = `
    query rerakuBlogs($shopSlug: String, $publishedAt: String, $page: Int, $per: Int) {
  rerakuBlogs(
    shopSlug: $shopSlug
    publishedAt: $publishedAt
    page: $page
    per: $per
  ) {
    items {
      displayId
      publishedStartAt
      title
      content
      eyeCatchingImage
      shopSlug
      shopName
    }
    pageInfo {
      totalPages
      currentPage
      isFirstPage
      isLastPage
      nextPage
      prevPage
      totalCount
    }
  }
}
    `;
export const useRerakuBlogsQuery = <
      TData = RerakuBlogsQuery,
      TError = unknown
    >(
      variables?: RerakuBlogsQueryVariables,
      options?: UseQueryOptions<RerakuBlogsQuery, TError, TData>
    ) =>
    useQuery<RerakuBlogsQuery, TError, TData>(
      variables === undefined ? ['rerakuBlogs'] : ['rerakuBlogs', variables],
      fetcher<RerakuBlogsQuery, RerakuBlogsQueryVariables>(RerakuBlogsDocument, variables),
      options
    );

useRerakuBlogsQuery.getKey = (variables?: RerakuBlogsQueryVariables) => variables === undefined ? ['rerakuBlogs'] : ['rerakuBlogs', variables];
;

useRerakuBlogsQuery.fetcher = (variables?: RerakuBlogsQueryVariables, options?: RequestInit['headers']) => fetcher<RerakuBlogsQuery, RerakuBlogsQueryVariables>(RerakuBlogsDocument, variables, options);
export const ShopDocument = `
    query Shop($id: Int!) {
  shop(id: $id) {
    id
    name
    pmShopId
    address
    isBookable
  }
}
    `;
export const useShopQuery = <
      TData = ShopQuery,
      TError = unknown
    >(
      variables: ShopQueryVariables,
      options?: UseQueryOptions<ShopQuery, TError, TData>
    ) =>
    useQuery<ShopQuery, TError, TData>(
      ['Shop', variables],
      fetcher<ShopQuery, ShopQueryVariables>(ShopDocument, variables),
      options
    );

useShopQuery.getKey = (variables: ShopQueryVariables) => ['Shop', variables];
;

useShopQuery.fetcher = (variables: ShopQueryVariables, options?: RequestInit['headers']) => fetcher<ShopQuery, ShopQueryVariables>(ShopDocument, variables, options);
export const ShopConditionRelationsDocument = `
    query ShopConditionRelations {
  shopConditionRelations {
    prefectures {
      id
      name
      sortNo
      prefectureArea {
        id
        name
      }
    }
    prefectureAreas {
      id
      name
      prefectures {
        id
        name
        sortNo
      }
    }
    railroadLines {
      id
      name
    }
    courseGenres {
      id
      name
      sortNo
    }
    courseCategories {
      courseCategoryId
      name
      sortNo
    }
  }
}
    `;
export const useShopConditionRelationsQuery = <
      TData = ShopConditionRelationsQuery,
      TError = unknown
    >(
      variables?: ShopConditionRelationsQueryVariables,
      options?: UseQueryOptions<ShopConditionRelationsQuery, TError, TData>
    ) =>
    useQuery<ShopConditionRelationsQuery, TError, TData>(
      variables === undefined ? ['ShopConditionRelations'] : ['ShopConditionRelations', variables],
      fetcher<ShopConditionRelationsQuery, ShopConditionRelationsQueryVariables>(ShopConditionRelationsDocument, variables),
      options
    );

useShopConditionRelationsQuery.getKey = (variables?: ShopConditionRelationsQueryVariables) => variables === undefined ? ['ShopConditionRelations'] : ['ShopConditionRelations', variables];
;

useShopConditionRelationsQuery.fetcher = (variables?: ShopConditionRelationsQueryVariables, options?: RequestInit['headers']) => fetcher<ShopConditionRelationsQuery, ShopConditionRelationsQueryVariables>(ShopConditionRelationsDocument, variables, options);
export const ShopForBookingDocument = `
    query ShopForBooking($slug: String!) {
  shop(slug: $slug) {
    id
    slug
    name
    pmShopId
    address
    tel
    isBookable
    isRequiredAdmissionFee
    hasOutsourcedStaff
    openingDate
    businessOpeningDate
    isPayAvailable
    pmCourseCategories {
      name
      pmCourseCategoryId
      remarks
      imageUrl
      isOption
      courses {
        pmCourseId
        courseMinutes
        imageUrl
        name
        price
        noTaxPrice
        remarks
        startAt
        endAt
        activeMale
        activeFemale
        courseType
      }
      options {
        name
        pmCourseId
        courseMinutes
        price
        noTaxPrice
        startAt
        endAt
        activeMale
        activeFemale
      }
    }
    staffs {
      name
      nickname
      pmStaffId
      nominatePrice
      nominateOptionName
      canBeNominated
      canBeNominatedBySex
      sex
      imageUrl
    }
    shopSettings {
      closed
      maleDisplay
      maleDisplayName
      maleNominatePrice
      maleStickId
      femaleDisplay
      femaleDisplayName
      femaleNominatePrice
      femaleStickId
    }
  }
}
    `;
export const useShopForBookingQuery = <
      TData = ShopForBookingQuery,
      TError = unknown
    >(
      variables: ShopForBookingQueryVariables,
      options?: UseQueryOptions<ShopForBookingQuery, TError, TData>
    ) =>
    useQuery<ShopForBookingQuery, TError, TData>(
      ['ShopForBooking', variables],
      fetcher<ShopForBookingQuery, ShopForBookingQueryVariables>(ShopForBookingDocument, variables),
      options
    );

useShopForBookingQuery.getKey = (variables: ShopForBookingQueryVariables) => ['ShopForBooking', variables];
;

useShopForBookingQuery.fetcher = (variables: ShopForBookingQueryVariables, options?: RequestInit['headers']) => fetcher<ShopForBookingQuery, ShopForBookingQueryVariables>(ShopForBookingDocument, variables, options);
export const ShopForCourseCategoriesDocument = `
    query ShopForCourseCategories($slug: String!) {
  shop(slug: $slug) {
    slug
    tel
    id
    name
    messageFromShopHtml
    isBookable
    staffs {
      name
    }
    recruitUrl
    brand {
      brandGroup {
        name
        id
      }
    }
    rerakuCourseCategories {
      courses {
        courseId
        name
        price
        courseMinutes
        remarks
      }
      courseCategoryId
      name
      remarks
      isOption
      imageUrl
    }
    rerakuBlogs {
      items {
        displayId
      }
    }
  }
}
    `;
export const useShopForCourseCategoriesQuery = <
      TData = ShopForCourseCategoriesQuery,
      TError = unknown
    >(
      variables: ShopForCourseCategoriesQueryVariables,
      options?: UseQueryOptions<ShopForCourseCategoriesQuery, TError, TData>
    ) =>
    useQuery<ShopForCourseCategoriesQuery, TError, TData>(
      ['ShopForCourseCategories', variables],
      fetcher<ShopForCourseCategoriesQuery, ShopForCourseCategoriesQueryVariables>(ShopForCourseCategoriesDocument, variables),
      options
    );

useShopForCourseCategoriesQuery.getKey = (variables: ShopForCourseCategoriesQueryVariables) => ['ShopForCourseCategories', variables];
;

useShopForCourseCategoriesQuery.fetcher = (variables: ShopForCourseCategoriesQueryVariables, options?: RequestInit['headers']) => fetcher<ShopForCourseCategoriesQuery, ShopForCourseCategoriesQueryVariables>(ShopForCourseCategoriesDocument, variables, options);
export const ShopForDetailDocument = `
    query ShopForDetail($slug: String!) {
  shop(slug: $slug) {
    slug
    id
    name
    status
    tel
    note
    recruitUrl
    isRequiredAdmissionFee
    admissionFeeText
    messageFromShopHtml
    nearestShops {
      items {
        name
        slug
        tel
        businessTimeText
        workingTime
        fullStations
        fullAddress
        companyId
        lat
        lng
        isBookable
        isNew
        distance
        isRenewal
        isRecentlyOpened
        openingDate
        renewalOpeningDate
        images {
          alt
          sortNo
          valiantImageUrls {
            middle {
              url
              w
              h
            }
            large {
              url
              w
              h
            }
          }
        }
        bookableDates {
          date
          isBookable
        }
      }
    }
    brand {
      brandGroup {
        name
        id
      }
    }
    workingTime
    pmShopId
    address
    fullAddress
    particularConditions {
      name
      id
    }
    fullStations
    businessTimeText
    access
    paymentMethods {
      id
      name
      paymentType
      imageUrl
      sortNo
    }
    postCode
    publishedEndAt
    publishedStartAt
    workingTime
    lat
    lng
    isBookable
    images {
      alt
      imageId
      sortNo
      type
      valiantImageUrls {
        middle {
          url
          w
          h
        }
        large {
          url
          w
          h
        }
      }
    }
    rerakuBlogs {
      items {
        displayId
        title
        shopSlug
        shopName
      }
    }
    prefectureName
    city {
      cityName
    }
    rerakuCourseCategories {
      name
    }
    staffs {
      name
    }
    recommendedCourses {
      course {
        pmCourseId
        pmCourseCategoryId
        name
        remarks
        courseMinutes
        price
        noTaxPrice
        sex
        activeMale
        activeFemale
        startAt
        endAt
        courseType
        imageUrl
        isPromotional
        promotionalImageUrl
      }
      isBookable
    }
  }
}
    `;
export const useShopForDetailQuery = <
      TData = ShopForDetailQuery,
      TError = unknown
    >(
      variables: ShopForDetailQueryVariables,
      options?: UseQueryOptions<ShopForDetailQuery, TError, TData>
    ) =>
    useQuery<ShopForDetailQuery, TError, TData>(
      ['ShopForDetail', variables],
      fetcher<ShopForDetailQuery, ShopForDetailQueryVariables>(ShopForDetailDocument, variables),
      options
    );

useShopForDetailQuery.getKey = (variables: ShopForDetailQueryVariables) => ['ShopForDetail', variables];
;

useShopForDetailQuery.fetcher = (variables: ShopForDetailQueryVariables, options?: RequestInit['headers']) => fetcher<ShopForDetailQuery, ShopForDetailQueryVariables>(ShopForDetailDocument, variables, options);
export const ShopForMessageDocument = `
    query ShopForMessage($slug: String!) {
  shop(slug: $slug) {
    id
    name
    slug
    tel
    isBookable
    recruitUrl
    brand {
      brandGroup {
        name
        id
      }
    }
    messageFromShopHtml
    rerakuBlogs {
      items {
        displayId
      }
    }
    rerakuCourseCategories {
      name
    }
    staffs {
      name
    }
  }
}
    `;
export const useShopForMessageQuery = <
      TData = ShopForMessageQuery,
      TError = unknown
    >(
      variables: ShopForMessageQueryVariables,
      options?: UseQueryOptions<ShopForMessageQuery, TError, TData>
    ) =>
    useQuery<ShopForMessageQuery, TError, TData>(
      ['ShopForMessage', variables],
      fetcher<ShopForMessageQuery, ShopForMessageQueryVariables>(ShopForMessageDocument, variables),
      options
    );

useShopForMessageQuery.getKey = (variables: ShopForMessageQueryVariables) => ['ShopForMessage', variables];
;

useShopForMessageQuery.fetcher = (variables: ShopForMessageQueryVariables, options?: RequestInit['headers']) => fetcher<ShopForMessageQuery, ShopForMessageQueryVariables>(ShopForMessageDocument, variables, options);
export const ShopForRerakuBlogDocument = `
    query ShopForRerakuBlog($slug: String!, $page: Int, $per: Int) {
  shop(slug: $slug) {
    slug
    id
    name
    tel
    recruitUrl
    messageFromShopHtml
    staffs {
      name
    }
    isBookable
    rerakuBlogs(page: $page, per: $per) {
      items {
        displayId
        publishedStartAt
        title
        content
        eyeCatchingImage
        shopSlug
        shopName
      }
      pageInfo {
        totalPages
        currentPage
        isFirstPage
        isLastPage
        nextPage
        prevPage
        totalCount
      }
    }
    rerakuCourseCategories {
      name
    }
  }
}
    `;
export const useShopForRerakuBlogQuery = <
      TData = ShopForRerakuBlogQuery,
      TError = unknown
    >(
      variables: ShopForRerakuBlogQueryVariables,
      options?: UseQueryOptions<ShopForRerakuBlogQuery, TError, TData>
    ) =>
    useQuery<ShopForRerakuBlogQuery, TError, TData>(
      ['ShopForRerakuBlog', variables],
      fetcher<ShopForRerakuBlogQuery, ShopForRerakuBlogQueryVariables>(ShopForRerakuBlogDocument, variables),
      options
    );

useShopForRerakuBlogQuery.getKey = (variables: ShopForRerakuBlogQueryVariables) => ['ShopForRerakuBlog', variables];
;

useShopForRerakuBlogQuery.fetcher = (variables: ShopForRerakuBlogQueryVariables, options?: RequestInit['headers']) => fetcher<ShopForRerakuBlogQuery, ShopForRerakuBlogQueryVariables>(ShopForRerakuBlogDocument, variables, options);
export const ShopForStaffDocument = `
    query ShopForStaff($slug: String!) {
  shop(slug: $slug) {
    id
    name
    slug
    tel
    isBookable
    recruitUrl
    messageFromShopHtml
    brand {
      brandGroup {
        name
        id
      }
    }
    rerakuBlogs {
      items {
        displayId
      }
    }
    rerakuCourseCategories {
      name
    }
    staffs {
      name
      nickname
      pmStaffId
      nominatePrice
      nominateOptionName
      canBeNominated
      canBeNominatedBySex
      sex
      imageUrl
      remark
    }
  }
}
    `;
export const useShopForStaffQuery = <
      TData = ShopForStaffQuery,
      TError = unknown
    >(
      variables: ShopForStaffQueryVariables,
      options?: UseQueryOptions<ShopForStaffQuery, TError, TData>
    ) =>
    useQuery<ShopForStaffQuery, TError, TData>(
      ['ShopForStaff', variables],
      fetcher<ShopForStaffQuery, ShopForStaffQueryVariables>(ShopForStaffDocument, variables),
      options
    );

useShopForStaffQuery.getKey = (variables: ShopForStaffQueryVariables) => ['ShopForStaff', variables];
;

useShopForStaffQuery.fetcher = (variables: ShopForStaffQueryVariables, options?: RequestInit['headers']) => fetcher<ShopForStaffQuery, ShopForStaffQueryVariables>(ShopForStaffDocument, variables, options);
export const ShopSearchConditionsDocument = `
    query shopSearchConditions($prefectureId: Int, $railroadLineIds: [Int!], $skipLoadDataCities: Boolean, $skipLoadDataRailroadLines: Boolean) {
  shopSearchConditions {
    particularConditions {
      id
      name
    }
    courseGenres {
      id
      name
    }
    allPrefectures: prefectures(isHaveShops: true) {
      id
      name
      shopCount
      sortNo
    }
    prefectureAreas {
      id
      name
      prefectures(isHaveShops: true) {
        id
        name
        shopCount
        sortNo
      }
    }
    cities(
      skipLoadData: $skipLoadDataCities
      all: true
      isHaveShops: true
      isDistinctByCityCode: true
      prefectureId: $prefectureId
    ) {
      items {
        id
        cityName
        shopCount
        prefecture {
          id
        }
      }
    }
    railroadLines(
      skipLoadData: $skipLoadDataRailroadLines
      isHaveShops: true
      ids: $railroadLineIds
      prefectureId: $prefectureId
    ) {
      id
      name
      shopCount
      sortNo
      railroadCompanyId
      railroadStations(all: true, isHaveShops: true, prefectureId: $prefectureId) {
        items {
          id
          name
          shopCount
          sortNo
        }
      }
    }
  }
}
    `;
export const useShopSearchConditionsQuery = <
      TData = ShopSearchConditionsQuery,
      TError = unknown
    >(
      variables?: ShopSearchConditionsQueryVariables,
      options?: UseQueryOptions<ShopSearchConditionsQuery, TError, TData>
    ) =>
    useQuery<ShopSearchConditionsQuery, TError, TData>(
      variables === undefined ? ['shopSearchConditions'] : ['shopSearchConditions', variables],
      fetcher<ShopSearchConditionsQuery, ShopSearchConditionsQueryVariables>(ShopSearchConditionsDocument, variables),
      options
    );

useShopSearchConditionsQuery.getKey = (variables?: ShopSearchConditionsQueryVariables) => variables === undefined ? ['shopSearchConditions'] : ['shopSearchConditions', variables];
;

useShopSearchConditionsQuery.fetcher = (variables?: ShopSearchConditionsQueryVariables, options?: RequestInit['headers']) => fetcher<ShopSearchConditionsQuery, ShopSearchConditionsQueryVariables>(ShopSearchConditionsDocument, variables, options);
export const ShopSearchTopDocument = `
    query shopSearchTop($isHaveShops: Boolean) {
  shopSearchConditions {
    prefectureAreas {
      id
      name
      prefectures(isHaveShops: $isHaveShops) {
        id
        name
        shopCount
        sortNo
        cities(isHaveShops: $isHaveShops) {
          items {
            id
            cityName
          }
        }
        railroadStations(isHaveShops: $isHaveShops) {
          items {
            id
            name
          }
        }
      }
    }
  }
}
    `;
export const useShopSearchTopQuery = <
      TData = ShopSearchTopQuery,
      TError = unknown
    >(
      variables?: ShopSearchTopQueryVariables,
      options?: UseQueryOptions<ShopSearchTopQuery, TError, TData>
    ) =>
    useQuery<ShopSearchTopQuery, TError, TData>(
      variables === undefined ? ['shopSearchTop'] : ['shopSearchTop', variables],
      fetcher<ShopSearchTopQuery, ShopSearchTopQueryVariables>(ShopSearchTopDocument, variables),
      options
    );

useShopSearchTopQuery.getKey = (variables?: ShopSearchTopQueryVariables) => variables === undefined ? ['shopSearchTop'] : ['shopSearchTop', variables];
;

useShopSearchTopQuery.fetcher = (variables?: ShopSearchTopQueryVariables, options?: RequestInit['headers']) => fetcher<ShopSearchTopQuery, ShopSearchTopQueryVariables>(ShopSearchTopDocument, variables, options);
export const ShopsDocument = `
    query Shops($courseGenreIds: [Int!], $courseCategoryIds: [Int!], $particularConditionIds: [Int!], $shopAreaIds: [Int!], $prefectureAreaIds: [Int!], $prefectureId: Int, $cityIds: [Int!], $railroadLineIds: [Int!], $railroadStationIds: [Int!], $q: String, $currentLocation: CurrentLocationInput, $isNew: Boolean, $isRenewal: Boolean, $isRecentlyOpened: Boolean, $page: Int!) {
  shops(
    courseGenreIds: $courseGenreIds
    courseCategoryIds: $courseCategoryIds
    particularConditionIds: $particularConditionIds
    shopAreaIds: $shopAreaIds
    prefectureAreaIds: $prefectureAreaIds
    prefectureId: $prefectureId
    cityIds: $cityIds
    railroadLineIds: $railroadLineIds
    railroadStationIds: $railroadStationIds
    q: $q
    currentLocation: $currentLocation
    isNew: $isNew
    isRenewal: $isRenewal
    isRecentlyOpened: $isRecentlyOpened
    page: $page
  ) {
    pageInfo {
      totalPages
      currentPage
      isFirstPage
      isLastPage
      nextPage
      prevPage
      totalCount
    }
    items {
      name
      slug
      tel
      businessTimeText
      workingTime
      fullStations
      fullAddress
      companyId
      lat
      lng
      isBookable
      isNew
      distance
      isRenewal
      isRecentlyOpened
      openingDate
      closingDate
      renewalOpeningDate
      images {
        alt
        sortNo
        valiantImageUrls {
          middle {
            url
            w
            h
          }
          large {
            url
            w
            h
          }
        }
      }
      bookableDates {
        date
        isBookable
      }
    }
  }
}
    `;
export const useShopsQuery = <
      TData = ShopsQuery,
      TError = unknown
    >(
      variables: ShopsQueryVariables,
      options?: UseQueryOptions<ShopsQuery, TError, TData>
    ) =>
    useQuery<ShopsQuery, TError, TData>(
      ['Shops', variables],
      fetcher<ShopsQuery, ShopsQueryVariables>(ShopsDocument, variables),
      options
    );

useShopsQuery.getKey = (variables: ShopsQueryVariables) => ['Shops', variables];
;

useShopsQuery.fetcher = (variables: ShopsQueryVariables, options?: RequestInit['headers']) => fetcher<ShopsQuery, ShopsQueryVariables>(ShopsDocument, variables, options);
export const TimeTablesByShopDocument = `
    query TimeTablesByShop($pmShopId: BigInt!, $courses: [BookingCourseInput!]!, $staffId: BigInt, $startDate: String!, $viewDay: Int!, $staffSexId: Int) {
  timeTables(
    pmShopId: $pmShopId
    courses: $courses
    staffId: $staffId
    startDate: $startDate
    viewDay: $viewDay
    staffSexId: $staffSexId
  ) {
    timeTableHourRange {
      startTime
      endTime
    }
    timeTablesByDate {
      date
      timeTablesByHalfHour {
        halfHour
        timeTableStatusByHalfHour {
          timeTableStatus
          timeTableStatusesEvery10Minutes {
            startTime
            status
          }
        }
      }
    }
  }
}
    `;
export const useTimeTablesByShopQuery = <
      TData = TimeTablesByShopQuery,
      TError = unknown
    >(
      variables: TimeTablesByShopQueryVariables,
      options?: UseQueryOptions<TimeTablesByShopQuery, TError, TData>
    ) =>
    useQuery<TimeTablesByShopQuery, TError, TData>(
      ['TimeTablesByShop', variables],
      fetcher<TimeTablesByShopQuery, TimeTablesByShopQueryVariables>(TimeTablesByShopDocument, variables),
      options
    );

useTimeTablesByShopQuery.getKey = (variables: TimeTablesByShopQueryVariables) => ['TimeTablesByShop', variables];
;

useTimeTablesByShopQuery.fetcher = (variables: TimeTablesByShopQueryVariables, options?: RequestInit['headers']) => fetcher<TimeTablesByShopQuery, TimeTablesByShopQueryVariables>(TimeTablesByShopDocument, variables, options);